// helper functions 

// Debounce function
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// to prevent bfcache issue on mobile safari, mostly when clicking back/forward button
// Javascript
if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
  window.onpageshow = function (event) {
    if (event.persisted) {
      document.querySelector("body").style.opacity = "0";
      window.location.href = window.location.href;
    }
  };
}
// to allow personalisation from cookies from plugin
var allowPersonalisation = false;

//Initialize Accordion

if (document.querySelector(".accordion-container")) {
  new Accordion(".accordion-container");
}

function getSliderSettings(numberofslider = 4, initialslide = 1) {
  return {
    centerMode: true,
    slidesToShow: numberofslider,
    dots: false,
    variableWidth: true,
    arrows: true,
    swipe: true,
    infinite: false,
    loop: true,
    initialSlide: initialslide,
    swipeToSlide: true,
    slidesToScroll: 1,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><span>Previous</span></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><span>Next</span></button>',

    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
          variableWidth: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          variableWidth: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          centerPadding: "10%",
          swipeToSlide: true,
          swipe: true,
          variableWidth: false,
        },
      },
    ],
  };
}

function getSliderSettingsDefault(numberofslider = 4, initialslide = 0) {
  return {
    centerMode: false,
    slidesToShow: numberofslider,
    dots: false,
    variableWidth: false,
    arrows: true,
    swipe: true,
    infinite: false,
    loop: true,
    initialSlide: initialslide,
    swipeToSlide: true,
    slidesToScroll: 1,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><span>Previous</span></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><span>Next</span></button>',

    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerMode: false,
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 0,
          centerPadding: "0",
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          centerPadding: "10%",
          swipeToSlide: true,
          swipe: true,
          infinite: false,
        },
      },
    ],
  };
}
//Carousel Script
if (document.querySelector(".glide__slides")) {
  var allSlides = document.querySelectorAll(".glide .glide__slides");
  var allSlidesArray = Array.prototype.slice.call(allSlides);

  $(".glide .glide__slides").each(function (index) {
    // console.log($(this).find("li").length);
    let slidescounter = "4";
    let initialslide = 0;
    let lengthofslides = $(this).find("li").length;
    if (lengthofslides >= 4) {
      slidescounter = 4;
      initialslide = 0;
    } else if (lengthofslides <= 3) {
      slidescounter = 1;
      initialslide = 0;
    }
    $(this).slick(getSliderSettingsDefault(slidescounter, initialslide));
  });
  // allSlidesArray.forEach((slide) => {
  // 	const glide = new Glide(slide, {
  // 		type: "carousel",
  // 		perView: 3,
  // 		perTouch: 1,
  // 		infinite: true,
  // 		focusAt: "center",
  // 		autoplay: false,
  // 		accessibility: true,
  // 		startAt: 2,
  // 		rewind: true,
  // 		classes: {
  // 			disabledArrow: "glide__arrow--disabled",
  // 		},
  // 		peek: {
  // 			before: 100,
  // 			after: 50,
  // 		},
  // 		perSwipe: "|",
  // 		breakpoints: {
  // 			800: {
  // 				perView: 1,
  // 				startAt: 1,
  // 				peek: 0,
  // 			},
  // 		},
  // 	}).mount();
  // });
}

//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
  allBtns.forEach((btn) => {
    if (btn.hasAttribute("href")) {
      let ctaLink = btn.getAttribute("href").split("/");

      if (ctaLink[2] !== currentHost) {
        btn.classList.add("external-link");
        btn.append(externalText);
      }
    }
  });
}
if (document.querySelector(".cta-btn")) {
  let currentHost = window.location.hostname;
  let ctaBtn = document.querySelector(".cta-btn");
  let ctaLink = ctaBtn.getAttribute("href").split("/");

  if (ctaLink[0] !== currentHost) {
    ctaBtn.classList.add("external-link");
    ctaBtn.append(externalText);
  }
}

////Pagination
if (document.querySelector(".navigation-pagination")) {
  let paginationList = document.querySelectorAll(
    ".navigation-pagination ul li"
  );

  if (paginationList[0].classList.contains("active")) {
    paginationList[0].style.position = "relative";
  }

  if (paginationList[paginationList.length - 1].classList.contains("active")) {
    paginationList[paginationList.length - 1].style.position = "relative";
  }
}

////Masonary
if (document.querySelector(".allcontainer")) {
  var elem = document.querySelector(".allcontainer");
  var msnry = new Masonry(elem, {
    // options
    itemSelector: ".item",
    columnWidth: ".grid-sizer",
    gutter: 15,
  });

  //Filters
  // const filterBtn = document.querySelectorAll('.filters button');
  // var allfilterBtn = Array.prototype.slice.call(filterBtn);
  //let allblocks = document.querySelectorAll('.item');
  let allblocks = Array.prototype.slice.call(
    document.querySelectorAll(".item")
  );
  let selectedValue;
  let selectedOption;
  let availableItems;
  let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", onClickChange);
  }

  //Click Filter
  function onClickChange() {
    selectedValue = this.value;
    // if(selectedValue !== 'all'){
    //   allblocks = document.querySelectorAll('.item.block');
    // }
    allblocks.forEach(function (block) {
      block.classList.remove("block");

      if (selectedValue == "all") {
        block.classList.add("block");
      }

      if (block.getAttribute("data-cat") == selectedValue) {
        block.classList.add("block");
      }
    });
    msnry.layout();

    availableItems = Array.prototype.slice.call(
      document.querySelectorAll(".item.block")
    );
    document
      .getElementById("select")
      .addEventListener("change", onSelectChange);
  }

  availableItems = Array.prototype.slice.call(
    document.querySelectorAll(".item.block")
  );

  document.getElementById("select").addEventListener("change", onSelectChange);

  function onSelectChange() {
    selectedOption = this.value;

    availableItems.forEach(function (item) {
      item.classList.remove("block");

      if (selectedOption == "all") {
        item.classList.add("block");
      }

      if (item.getAttribute("data-tag") == selectedOption) {
        item.classList.add("block");
      }
    });

    //Filter Click
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", onClickChange);
    }

    msnry.layout();
  }

  /////Script_AJAX
  /* Ajax functions */
  $(document).ready(function () {
    //onclick
    $("#loadMore").on("click", function (e) {
      e.preventDefault();
      //init
      var that = $(this);
      var page = $(this).data("page");
      var newPage = page + 1;
      var ajaxurl = that.data("url");
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: "post",
        data: {
          page: page,
          action: "ajax_script_load_more",
        },
        error: function (response) {
          console.log(response);
        },
        success: function (response) {
          //check
          if (response == 0) {
            $(".allcontainer").append(
              '<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>'
            );
            $("#loadMore").hide();
          } else {
            that.data("page", newPage);
            $("#ajax-primary").append(response);

            msnry = new Masonry(elem, {
              // options
              itemSelector: ".item",
              columnWidth: ".grid-sizer",
              gutter: 15,
            });

            msnry.layout();
          }
        },
      });
    });
  });
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
  document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
  var btnbgColor = $(this).css("backgroundColor");
  var btnColor = $(this).css("color");

  $(this)
    .mouseenter(function () {
      $(this).css({
        "background-color": btnColor,
        color: btnbgColor,
        "border-color": btnColor,
      });
    })
    .mouseleave(function () {
      $(this).css({
        "background-color": btnbgColor,
        color: btnColor,
        "border-color": btnbgColor,
      });
    });
});

//

// window.addEventListener('DOMContentLoaded', (event) => {
// 	function removefocusclass(){
// 		var mainmenufocus= document.querySelectorAll(".only-desktop-menu a");
// 	if(mainmenufocus){
// 		for(var x=0; x<mainmenufocus.length; x++){
// 		let focusedOrHasFocusedmenuitem = mainmenufocus[x].parentNode.matches(':focus-within');

//                 if(!focusedOrHasFocusedmenuitem){
// 					var focusedelement= mainmenufocus[x];
// 					focusedelement.parentNode.classList.remove("focus");
// 					focusedelement.parentNode.classList.remove("opensubmenu");
// 					focusedelement.setAttribute("aria-expanded", false);

// 				}
// 	}
// 	}
// 	}
// 	// alert ("page loaded shachi");
// 	var mainmenufocus= document.querySelectorAll(".only-desktop-menu a");
// 	if(mainmenufocus){
// 		for(var x=0; x<mainmenufocus.length; x++){

// 			mainmenufocus[x].addEventListener("focus", function(e){

// 				var focusedelement= e.target;
// 				focusedelement.parentNode.classList.add("focus");
// 				if(e.target.parentNode.classList.contains("has-children")){
// 					e.target.setAttribute("aria-expanded", true);
// 				}

// 			}
// 			)
// 			mainmenufocus[x].addEventListener("focusout", function(e){

// 				//console.log(e.target.parentNode.contains(document.activeElement));
// 				let focusedOrHasFocused = e.target.parentNode.matches(':focus-within');
// 				// console.log(focusedOrHasFocused);
//                 if(!focusedOrHasFocused){
// 					var focusedelement= e.target;
// 					focusedelement.parentNode.classList.remove("focus");
// 					focusedelement.parentNode.classList.remove("opensubmenu");

// 					if(e.target.parentNode.classList.contains("has-children")){
// 						e.target.setAttribute("aria-expanded", false);
// 					}
// 				}

// 				removefocusclass();
// 			}
// 			)

// 			mainmenufocus[x].addEventListener("keydown", function(e){

//                 //  console.log(e.which);
// 				//  console.log(e.keyCode);
// 				 var keypressed= e.which || e.keyCode;
// 				 var enterpressed= e.which || e.keyCode;

// 					if(keypressed==9){
// 						if(e.target.parentNode.classList.contains("has-children")){
//                             // e.target.nextSibling.focus();
// 							var focusedelement= e.target;

// 							//   e.preventDefault();
// 							//   focusedelement.parentNode.classList.add("focus");
// 							// console.log(e.target.parentNode);
// 							var focusremove= e.target.parentNode.querySelector(".submenu a");
// 							//focusremove.focus();
// 							//  console.log(focusremove);
// 							// e.returnValue = true;
// 						}
// 					}
// 					// if(enterpressed==13){
// 					// 	if(e.target.parentNode.classList.contains("has-children")){
// 					// 		e.preventDefault();
// 					// 		var focuswithenter= e.target;
// 					// 		focuswithenter.parentNode.classList.add("opensubmenu");

// 					// 	}
// 					// }

// 			}
// 			)
// 			mainmenufocus[x].addEventListener("click", function(e){

// 				if(e.target.parentNode.classList.contains("has-children")){

// 					e.preventDefault();

// 					var focuswithenter= e.target;

// 					// focuswithenter.parentNode.classList.add("opensubmenu");
// 					if(focuswithenter.parentNode.classList.contains("opensubmenu")){

// 						focuswithenter.parentNode.classList.remove("opensubmenu");
// 					}
// 					else{

// 						focuswithenter.parentNode.classList.add("opensubmenu");
// 					}

// 				}

// 			}

// 	  )

// 		}

// 	}

// }
// )

window.addEventListener("DOMContentLoaded", (event) => {
  mobiletopmenuaccessibility();
});

function mobiletopmenuaccessibility() {
  var sidemenu = document.querySelector(".only-mobile-menu");
  if (sidemenu) {
    //const  focusableElementssubmenu = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableElementssubmenu = "ul:not(.nav__sub)>li>a";
    const firstFocusableElementsubmenu = sidemenu.querySelectorAll(
      focusableElementssubmenu
    )[0]; // get first element to be focused inside modal
    const focusableContentsubmenu = sidemenu.querySelectorAll(
      focusableElementssubmenu
    );

    const lastFocusableElementsubmenu =
      focusableContentsubmenu[focusableContentsubmenu.length - 1]; // get last element to be focused inside modal

    document.addEventListener("keydown", function (e) {
      let isTabPressed = e.key === "Tab" || e.keyCode === 9;
      let isEnterPressed = e.keyCode === 13;
      //   if(isEnterPressed){
      //     if (document.activeElement === firstFocusableElementsubmenu) {
      //       sidemenu.style.display = "none";
      //       e.preventDefault();
      //     }
      //   }

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElementsubmenu) {
          lastFocusableElementsubmenu.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === lastFocusableElementsubmenu) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          document
            .querySelector(".footer-navigation-buttons .mobile-menu-cta a")
            .focus(); // add focus for the first focusable element
          // firstFocusableElementsubmenu.focus(); // add focus for the first focusable element
          e.preventDefault();
        }
      }
    });
  }
  // second level menu focus trap
  secondlevelmenyaccessibility();
  // thirdlevelmenyaccessibility();
}

function secondlevelmenyaccessibility() {
  var sidemenu = document.querySelectorAll(
    ".only-mobile-menu ul.nav__sub.sub:not(.subsub)"
  );
  if (sidemenu) {
    // startforeach for all submenus
    for (let i = 0; i < sidemenu.length; i++) {
      //const  focusableElementssubmenu = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const focusableElementssubmenu = "li.subc a";
      const firstFocusableElementsubmenu = sidemenu[i].querySelectorAll(
        focusableElementssubmenu
      )[0]; // get first element to be focused inside modal
      const focusableContentsubmenu = sidemenu[i].querySelectorAll(
        focusableElementssubmenu
      );

      const lastFocusableElementsubmenu =
        focusableContentsubmenu[focusableContentsubmenu.length - 1]; // get last element to be focused inside modal

      sidemenu[i].addEventListener("keydown", function (e) {
        let isTabPressed = e.key === "Tab" || e.keyCode === 9;
        let isEnterPressed = e.keyCode === 13;

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          // if shift key pressed for shift + tab combination
          if (document.activeElement === firstFocusableElementsubmenu) {
            lastFocusableElementsubmenu.focus(); // add focus for the last focusable element
            e.preventDefault();
          }
        } else {
          // if tab key is pressed
          if (document.activeElement === lastFocusableElementsubmenu) {
            // if focused has reached to last focusable element then focus first focusable element after pressing tab
            //document.querySelector(".hamicon").focus(); // add focus for the first focusable element
            firstFocusableElementsubmenu.parentNode.parentNode
              .querySelector(".sub__close")
              .focus(); // add focus for the first focusable element
            //firstFocusableElementsubmenu.focus(); // add focus for the first focusable element
            e.preventDefault();
          }
        }
      });
    }
    // end foreach for all sub menus
  }
  // thirdlevelmenyaccessibility();
}

function thirdlevelmenyaccessibility() {
  var sidemenu = document.querySelectorAll(
    ".only-mobile-menu ul.nav__sub.subsub"
  );
  //console.log(sidemenu.length + " subsub menus")
  if (sidemenu) {
    for (let i = 0; i < sidemenu.length; i++) {
      //const  focusableElementssubmenu = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const focusableElementssubmenu = "li.subsubc>a";
      const firstFocusableElementsubmenu = sidemenu[i].querySelectorAll(
        focusableElementssubmenu
      )[0]; // get first element to be focused inside modal
      const focusableContentsubmenu = sidemenu[i].querySelectorAll(
        focusableElementssubmenu
      );

      const lastFocusableElementsubmenu =
        focusableContentsubmenu[focusableContentsubmenu.length - 1]; // get last element to be focused inside modal

      sidemenu[i].addEventListener("keydown", function (e) {
        let isTabPressed = e.key === "Tab" || e.keyCode === 9;
        let isEnterPressed = e.keyCode === 13;

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          // if shift key pressed for shift + tab combination
          if (document.activeElement === firstFocusableElementsubmenu) {
            //console.log("inside sub sub menu first");

            lastFocusableElementsubmenu.focus(); // add focus for the last focusable element
            e.preventDefault();
          }
        } else {
          // if tab key is pressed

          if (document.activeElement === lastFocusableElementsubmenu) {
            //console.log("inside sub sub menu last");

            // if focused has reached to last focusable element then focus first focusable element after pressing tab
            //document.querySelector(".hamicon").focus(); // add focus for the first focusable element
            firstFocusableElementsubmenu.parentNode.parentNode
              .querySelector(".sub__close")
              .focus(); // add focus for the first focusable element
            e.preventDefault();
          }
        }
      });
    }
  }
}

function addactiveclasstomenu(menuselector) {
  // menuselector = ".megamenu li";
  let currenturl = window.location.origin + window.location.pathname;
  let allmenuitems = document.querySelectorAll(menuselector);
  if (allmenuitems) {
    for (let i = 0; i < allmenuitems.length; i++) {
      let currentli = allmenuitems[i];
      currentli.classList.remove("active");
    }

    for (let i = 0; i < allmenuitems.length; i++) {
      let currentli = allmenuitems[i];
      let allainside = allmenuitems[i].querySelectorAll("a");
      if (allainside) {
        for (let j = 0; j < allainside.length; j++) {
          let currentahref = allainside[j].href;
          if (currentahref == currenturl) {
            currentli.classList.add("active");
          }
        }
      }
    }
  }
}
// adding active classes to cta's

// function buttonclickevents(){
// 	let openmenubutton= document.querySelector(".menucta");

// 			openmenubutton.addEventListener("click", function(e){
// 				// e.preventDefault();
// 				e.target.classList.toggle("active");

// 			})
// 		}

// buttonclickevents();

let openmenubutton = document.querySelector(".menucta");
if (openmenubutton) {
  openmenubutton.addEventListener("click", function (e) {
    e.preventDefault();
    var menutxt = e.target;
    let menuwithctaa = document.querySelector(".menu-with-ctaa");
    if (menuwithctaa) {
      // menuwithctaa.classList.toggle("active");
      if (menuwithctaa.classList.contains("active")) {
        menuwithctaa.style.transform = "translate(0,-100%)";

        setTimeout(function () {
          menuwithctaa.classList.toggle("active");

          menuwithctaa.style.transform = "translate(0,0)";
        }, 300);
      } else {
        menuwithctaa.classList.toggle("active");
      }
    }
    e.target.classList.toggle("active");
    if (e.target.getAttribute("aria-expanded") == "false") {
      e.target.setAttribute("aria-expanded", true);
      menutxt.innerHTML = "Close";
    } else {
      e.target.setAttribute("aria-expanded", false);
      menutxt.innerHTML = "Menu";
    }
  });
  openmenubutton.addEventListener("keydown", function (e) {
    //    e.preventDefault();
    let isEnterPressed = e.keyCode === 13;
    if (isEnterPressed) {
      e.preventDefault();
      var menutxt = e.target;
      let menuwithctaa = document.querySelector(".menu-with-ctaa");
      if (menuwithctaa) {
        menuwithctaa.classList.toggle("active");
      }
      e.target.classList.toggle("active");
      if (e.target.getAttribute("aria-expanded") == "false") {
        e.target.setAttribute("aria-expanded", true);
        menutxt.innerHTML = "Menu";
      } else {
        e.target.setAttribute("aria-expanded", false);
        menutxt.innerHTML = "Close";
      }
    }
  });

  openmenubutton.addEventListener("focus", function (e) {
    e.preventDefault();

    var menutxt = e.target;
    let menuwithctaa = document.querySelector(".menu-with-ctaa");
    if (menuwithctaa) {
      menuwithctaa.classList.toggle("active");
      //menuwithctaa.classList.remove("active");
    }
    e.target.classList.toggle("active");
    if (e.target.getAttribute("aria-expanded") == "false") {
      e.target.setAttribute("aria-expanded", true);
      menutxt.innerHTML = "Menu";
    } else {
      e.target.setAttribute("aria-expanded", false);
      menutxt.innerHTML = "Close";
    }
  });
  openmenubutton.addEventListener("mouseover", function (e) {
    e.preventDefault();
    var menutxt = e.target;
    let menuwithctaa = document.querySelector(".menu-with-ctaa");
    // if (menutxt.classList.contains("active")) {

    // 	if (menuwithctaa) {
    // 		menuwithctaa.classList.remove("active");
    // 	}
    // 	menutxt.classList.remove("active");
    // 	e.target.setAttribute("aria-expanded", false);
    // 	menutxt.innerHTML = 'Menu';
    // }
    // else {

    if (menuwithctaa) {
      menuwithctaa.classList.add("active");
    }
    menutxt.classList.add("active");
    e.target.setAttribute("aria-expanded", true);
    menutxt.innerHTML = "Close";
    // }
  });
}
let mouseleaveeventonmenu = document.querySelectorAll(".menu-with-ctaa");
// let removeactiveclassmenuctaa= document.querySelector(".menu-cta-open-button .menucta");
if (mouseleaveeventonmenu) {
  for (let x = 0; x < mouseleaveeventonmenu.length; x++) {
    mouseleaveeventonmenu[x].addEventListener("mouseleave", function (e) {
      e.preventDefault();
      mouseleaveeventonmenu[x].style.transform = "translate(0,-100%)";

      setTimeout(function () {
        mouseleaveeventonmenu[x].classList.remove("active");

        mouseleaveeventonmenu[x].style.transform = "translate(0,0)";
      }, 300);
      setTimeout(function () {
        let removeactiveclassmenuctaa = document.querySelector(
          ".menu-cta-open-button .menucta"
        );
        if (
          removeactiveclassmenuctaa &&
          removeactiveclassmenuctaa.classList.contains("active")
        ) {
          removeactiveclassmenuctaa.classList.remove("active");
          removeactiveclassmenuctaa.setAttribute("aria-expanded", false);
          removeactiveclassmenuctaa.innerHTML = "Menu";
        }
      }, 100);
    });
  }
}
let openjobcta = document.querySelector(".alljobscta");
if (openjobcta) {
  openjobcta.addEventListener("click", function (e) {
    e.target.classList.toggle("active");
  });
}

let openmobilemenubutton = document.querySelectorAll(".mobile-menu-cta a");
if (openmobilemenubutton) {
  for (var x = 0; x < openmobilemenubutton.length; x++) {
    openmobilemenubutton[x].addEventListener("click", function (e) {
      e.preventDefault();
      var menutxt = e.currentTarget;
      // console.log(menutxt);
      // if (menutxt == '<i class="ham-icon"></i> Menu') {

      //     menutxt.innerHTML = '<i class="ham-icon"></i> Close';
      // } else {
      //     menutxt.innerHTML = 'inactive';
      // }
      menutxt.parentNode.classList.toggle("active");

      if (menutxt.getAttribute("aria-expanded") == "false") {
        menutxt.setAttribute("aria-expanded", true);
        menutxt.innerHTML = '<i class="ham-icon"></i> Menu';
      } else {
        menutxt.setAttribute("aria-expanded", false);
        menutxt.innerHTML = '<i class="ham-icon"></i> Close';
      }

      openMobileNav();
      menutxt.classList.toggle("active");
    });
  }
}

let openalljobscta = document.querySelector(".mobile-alljobs-cta a");
if (openalljobscta) {
  openalljobscta.addEventListener("click", function (e) {
    e.target.parentNode.classList.toggle("active");
  });
}
// e.target.classList.toggle("active");

// mobile menu accessibility

let focusonclosebutton = document.querySelector(".mobile-menu-cta a");
if (focusonclosebutton) {
  focusonclosebutton.addEventListener("keydown", function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === 9;

    if (isTabPressed) {
      if (e.target.parentNode.classList.contains("active")) {
        e.preventDefault();
        let firstmenuitemfocus = document.querySelector(
          ".only-mobile-menu .nav li a"
        );
        firstmenuitemfocus.focus();
      }
    }
  });
}
// desktop menu accessibility
let focusonclosebuttonmenu = document.querySelector(".menu-cta-open-button a");
if (focusonclosebuttonmenu) {
  focusonclosebuttonmenu.addEventListener("keydown", function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === 9;
    let isShiftPressed = e.shiftKey;
    if (isTabPressed) {
      //console.log("here",e.currentTarget.classList.contains("active"),e.currentTarget)
      if (e.currentTarget.classList.contains("active")) {
        e.preventDefault();
        let firstmenuitembuttonfocus = document.querySelector(
          ".menu-with-ctaa .megamenu li:nth-child(2) a"
        );
        firstmenuitembuttonfocus.focus();
      }
    }
  });
}

let firstmenuitembuttonfocus = document.querySelector(
  ".menu-with-ctaa .megamenu li:nth-child(2) a"
);
if (firstmenuitembuttonfocus) {
  firstmenuitembuttonfocus.addEventListener("keydown", function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === 9;
    let isShiftPressed = e.shiftKey;
    if (isShiftPressed && isTabPressed) {
      e.preventDefault();
      let focusonclosebuttonmenuopen = document.querySelector(
        ".menu-cta-open-button .menucta.active"
      );
      focusonclosebuttonmenuopen.focus();
    }
  });
}

let submenuitemtoggle = document.querySelectorAll(
  ".megamenu .submenu-level-1 .sub-menu-item.has-children>a"
);

if (submenuitemtoggle) {
  for (let x = 0; x < submenuitemtoggle.length; x++) {
    // submenuitemtoggle[x].addEventListener("click", function (e) {
    // 	// e.preventDefault();
    // 	// console.log(e.target);
    // 	let submenuleveltwo = e.target.parentNode.querySelector(".submenu-level-2");

    // 	if (submenuleveltwo) {

    // 		if (!submenuleveltwo.classList.contains("active")) {

    // 			submenuleveltwo.classList.add("current");

    // 		}

    // 	}
    // 	let allLeveltwoMenu = document.querySelectorAll(".megamenu .submenu-level-2");

    // 	if (allLeveltwoMenu) {

    // 		for (let y = 0; y < allLeveltwoMenu.length; y++) {

    // 			allLeveltwoMenu[y].classList.remove("active");
    // 		}
    // 		if (submenuleveltwo.classList.contains("current")) {
    // 			submenuleveltwo.classList.add("active");
    // 			submenuleveltwo.classList.remove("current");
    // 		}
    // 	}

    // })
    submenuitemtoggle[x].addEventListener("mouseover", function (e) {
      // e.preventDefault();
      // console.log(e.target);
      let submenuleveltwo =
        e.target.parentNode.querySelector(".submenu-level-2");
      // if(submenuleveltwo.classList.contains("active")){
      // 	// submenuleveltwo.classList.toggle("active");
      //     submenuleveltwo.style.animation="animatelefttorightmenu .7s ease-in-out";
      // }

      // if (submenuleveltwo) {

      // 	if(!submenuleveltwo.classList.contains("active")) {

      // 		submenuleveltwo.classList.add("current");

      // 	}

      // }
      let allLeveltwoMenu = document.querySelectorAll(
        ".megamenu .submenu-level-2"
      );

      if (allLeveltwoMenu) {
        // for (let y = 0; y < allLeveltwoMenu.length; y++) {

        // 	allLeveltwoMenu[y].classList.remove("active");
        // }
        // if (submenuleveltwo.classList.contains("current")) {
        if (submenuleveltwo) {
          submenuleveltwo.classList.add("active");
        }

        // 	// submenuleveltwo.style.animation="animatelefttorightmenu .7s ease-in-out";
        // 	submenuleveltwo.classList.remove("current");
        // }
      }
    });

    submenuitemtoggle[x].addEventListener("keydown", function (e) {
      let isEnterPressed = e.keyCode === 13;
      if (isEnterPressed) {
        e.preventDefault();
        let submenuleveltwo =
          e.target.parentNode.querySelector(".submenu-level-2");
        // console.log(submenuleveltwo);
        if (submenuleveltwo) {
          if (!submenuleveltwo.classList.contains("active")) {
            submenuleveltwo.classList.add("current");
          }
        }
        let allLeveltwoMenu = document.querySelectorAll(
          ".megamenu .submenu-level-2"
        );
        if (allLeveltwoMenu) {
          // console.log(allLeveltwoMenu);
          for (let y = 0; y < allLeveltwoMenu.length; y++) {
            allLeveltwoMenu[y].classList.remove("active");
          }
          if (submenuleveltwo.classList.contains("current")) {
            submenuleveltwo.classList.add("active");
            submenuleveltwo.classList.remove("current");
          }
        }
      }
    });
  }
}
let submenuitemtoggleli = document.querySelectorAll(
  ".megamenu .submenu-level-1 .sub-menu-item.has-children"
);
if (submenuitemtoggleli) {
  for (let x = 0; x < submenuitemtoggleli.length; x++) {
    submenuitemtoggleli[x].addEventListener("mouseleave", function (e) {
      // e.preventDefault();
      // console.log(e.target);
      // let submenuleveltwo = e.target.querySelector(".submenu-level-2");

      // if (submenuleveltwo) {

      // 	if (!submenuleveltwo.classList.contains("active")) {

      // 		submenuleveltwo.classList.add("current");

      // 	}

      // }
      // let allLeveltwoMenu = document.querySelectorAll(".megamenu .submenu-level-2");

      // if (allLeveltwoMenu) {

      // 	for (let y = 0; y < allLeveltwoMenu.length; y++) {

      // 		allLeveltwoMenu[y].classList.remove("active");
      // 	}
      // 	if (submenuleveltwo.classList.contains("current")) {
      // 		submenuleveltwo.classList.add("active");
      // 		submenuleveltwo.classList.remove("current");
      // 	}
      // }

      //    console.log(e.currentTarget.querySelector("ul"));
      //    e.currentTarget.querySelector("ul").classList.remove("active");
      let submenuleveltwo =
        e.target.parentNode.querySelector(".submenu-level-2");
      // submenuleveltwo.style.animation="animatelefttorightmenu .7s";

      // if (submenuleveltwo) {

      // 	if (!submenuleveltwo.classList.contains("active")) {

      // 		submenuleveltwo.classList.remove("current");

      // 	}

      // }
      if (e.currentTarget.querySelector(".submenu-level-2.active")) {
        e.currentTarget
          .querySelector(".submenu-level-2.active")
          .classList.remove("active");
      }
    });
  }
}

// menu professions child's child mouseout
// let submenuitemtoggleli= document.querySelectorAll(".megamenu .submenu-level-1 .sub-menu-item.has-children .submenu-level-2.active");
//    if(submenuitemtoggleli){
// 	  for(let x=0; x<submenuitemtoggleli.length; x++){

//    submenuitemtoggleli[x].addEventListener("mouseleave", function (e) {
// 	// e.preventDefault();
// 	// console.log(e.target);
// 	// let submenuleveltwo = e.target.querySelector(".submenu-level-2");

// 	// if (submenuleveltwo) {

// 	// 	if (!submenuleveltwo.classList.contains("active")) {

// 	// 		submenuleveltwo.classList.add("current");

// 	// 	}

// 	// }
// 	// let allLeveltwoMenu = document.querySelectorAll(".megamenu .submenu-level-2");

// 	// if (allLeveltwoMenu) {

// 	// 	for (let y = 0; y < allLeveltwoMenu.length; y++) {

// 	// 		allLeveltwoMenu[y].classList.remove("active");
// 	// 	}
// 	// 	if (submenuleveltwo.classList.contains("current")) {
// 	// 		submenuleveltwo.classList.add("active");
// 	// 		submenuleveltwo.classList.remove("current");
// 	// 	}
// 	// }

// //    console.log(e.currentTarget.querySelector("ul"));
// //    e.currentTarget.querySelector("ul").classList.remove("active");
//    let submenuleveltwo = e.target.parentNode.querySelector(".submenu-level-2");
// 			// submenuleveltwo.style.animation="animatelefttorightmenu .7s";

// 			if (submenuleveltwo) {

// 				if (!submenuleveltwo.classList.contains("active")) {

// 					submenuleveltwo.classList.remove("current");

// 				}

// 			}

// })
// 	}
// }

//
let submenuleveltwolastelement = document.querySelectorAll(
  ".megamenu .submenu-level-2 li:last-child a"
);
if (submenuleveltwolastelement) {
  for (let x = 0; x < submenuleveltwolastelement.length; x++) {
    submenuleveltwolastelement[x].addEventListener("keydown", function (e) {
      let isTabPressed = e.key === "Tab" || e.keyCode === 9;
      let isShiftPressed = e.shiftKey;
      if (isShiftPressed && isTabPressed) {
      } else if (isTabPressed) {
        e.preventDefault();
        let focusonfirstsitem =
          e.target.parentNode.parentNode.parentNode.querySelector("a");
        // console.log(focusonfirstsitem);
        focusonfirstsitem.focus();
      }
      // if (isTabPressed) {
      // 	e.preventDefault();
      // 	let focusonfirstsitem = e.target.parentNode.parentNode.parentNode.querySelector("a");
      // 	// console.log(focusonfirstsitem);
      // 	focusonfirstsitem.focus();
      // }
    });
  }
}
let focusonlastchild = document.querySelectorAll(".megamenu a:last-child");
if (focusonlastchild) {
  let lastfocuablelementa = focusonlastchild[focusonlastchild.length - 1];
  lastfocuablelementa.addEventListener("keydown", function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === 9;
    let isShiftPressed = e.shiftKey;

    if (isShiftPressed && isTabPressed) {
      let focusonlastlimenu = document.querySelector(
        ".menu-with-ctaa.desktop-only a"
      );
    } else if (isTabPressed) {
      e.preventDefault();

      let focusonclosemenu = document.querySelector(
        ".menu-cta-open-button .menucta.active"
      );
      focusonclosemenu.focus();
    }
  });
}
// let focusonlastsubmenuoneli =document.querySelectorAll(".megamenu a:last-child");
// if (focusonlastsubmenuoneli) {

// 	let lastfocuablelementab = focusonlastsubmenuoneli[focusonlastsubmenuoneli.length - 1];
// 	lastfocuablelementab.addEventListener("keydown", function (e) {
// 		let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
// 		let isShiftPressed = e.shiftKey;

// 		if(isShiftPressed && isTabPressed) {
// 			e.preventDefault();
// 	let focusonlastlimenu= document.querySelector(".megamenu li:last-child");
// 	focusonlastlimenu.focus();
// 	  }
// 	})
// }

let submenuleveltwooa = document.querySelectorAll(
  ".megamenu .sub-menu-item.has-children a"
);
if (submenuleveltwooa) {
  for (let x = 0; x < submenuleveltwooa.length; x++) {
    submenuleveltwooa[x].addEventListener("click", function (e) {
      e.preventDefault();
      if (e.target.getAttribute("aria-expanded") == "false") {
        e.target.setAttribute("aria-expanded", true);
      } else {
        e.target.setAttribute("aria-expanded", false);
      }
    });
    submenuleveltwooa[x].addEventListener("mouseover", function (e) {
      e.preventDefault();
      if (e.target.getAttribute("aria-expanded") == "false") {
        e.target.setAttribute("aria-expanded", true);
      } else {
        e.target.setAttribute("aria-expanded", false);
      }
    });
    submenuleveltwooa[x].addEventListener("mouseout", function (e) {
      e.preventDefault();
      if (e.target.getAttribute("aria-expanded") == "false") {
        e.target.setAttribute("aria-expanded", true);
      } else {
        e.target.setAttribute("aria-expanded", false);
      }
    });
    submenuleveltwooa[x].addEventListener("keydown", function (e) {
      // e.preventDefault();
      if (e.target.getAttribute("aria-expanded") == "false") {
        e.target.setAttribute("aria-expanded", true);
      } else {
        e.target.setAttribute("aria-expanded", false);
      }
    });
  }
}

// footer accordion scripts
// do it for mobile only
if (document.querySelector("body").offsetWidth <= 960) {
  let footer_accordion_li = document.querySelectorAll(
    "#menu-primary-footer li.menu-item-has-children>a"
  );
  if (footer_accordion_li) {
    for (let x = 0; x < footer_accordion_li.length; x++) {
      footer_accordion_li[x].addEventListener("click", function (e) {
        e.preventDefault();
        // e.target.parentNode.classList.toggle("active");

        if (!e.target.parentNode.classList.contains("active")) {
          e.target.parentNode.classList.add("current");
        }

        let allLeveltwoMenu = document.querySelectorAll(
          "#menu-primary-footer li.menu-item-has-children"
        );
        if (allLeveltwoMenu) {
          for (let y = 0; y < allLeveltwoMenu.length; y++) {
            allLeveltwoMenu[y].classList.remove("active");
            allLeveltwoMenu[y]
              .querySelector("a")
              .setAttribute("aria-expanded", false);
          }
          if (e.target.parentNode.classList.contains("current")) {
            e.target.parentNode.classList.add("active");
            e.target.parentNode.classList.remove("current");
            e.target.setAttribute("aria-expanded", true);
          }
        }
      });
      footer_accordion_li[x].addEventListener("keydown", function (e) {
        var code = e.keyCode ? e.keyCode : e.which;
        if (code == 13) {
          //Enter keycode
          e.preventDefault();
          // e.target.parentNode.classList.toggle("active");
          if (!e.target.parentNode.classList.contains("active")) {
            e.target.parentNode.classList.add("current");
          }

          let allLeveltwoMenu = document.querySelectorAll(
            "#menu-primary-footer li.menu-item-has-children"
          );
          if (allLeveltwoMenu) {
            for (let y = 0; y < allLeveltwoMenu.length; y++) {
              allLeveltwoMenu[y].classList.remove("active");
            }
            if (e.target.parentNode.classList.contains("current")) {
              e.target.parentNode.classList.add("active");
              e.target.parentNode.classList.remove("current");
            }
          }
        }
      });
    }
  }
}

// closing last menu item when focus out
let footer_menu_last_child = document.querySelectorAll(
  "#menu-primary-footer li.menu-item-has-children"
);
if (footer_menu_last_child) {
  let last_li_tag = footer_menu_last_child[footer_menu_last_child.length - 1];
  if (last_li_tag) {
    let last_submenu_ul_tag = last_li_tag.querySelectorAll("ul.sub-menu li");
    if (last_submenu_ul_tag) {
      let last_submenu_li_tag =
        last_submenu_ul_tag[last_submenu_ul_tag.length - 1];
      let last_submenu_a_tag = last_submenu_li_tag.querySelector("a");
      if (last_submenu_a_tag) {
        last_submenu_a_tag.addEventListener("keydown", function (e) {
          let isTabPressed = e.key === "Tab" || e.keyCode === 9;
          if (isTabPressed) {
            e.target.parentNode.parentNode.parentNode.classList.remove(
              "active"
            );
          }
        });
      }
    }
  }
}

// closing menu on shift tab pressed
let footer_menu_first_child = document.querySelectorAll(
  "#menu-primary-footer li.menu-item-has-children > a"
);
if (footer_menu_first_child) {
  for (let a = 0; a < footer_menu_first_child.length; a++) {
    footer_menu_first_child[a].addEventListener("keydown", function (e) {
      let isShiftPressed = e.shiftKey;
      if (isShiftPressed) {
        e.target.parentNode.classList.remove("active");
      }
    });
  }
}

// hero animation core functions
// function to controll scroll animation
// take current frame as argument

function scrollcontrolfunction(frame) {
  //     let scrollcontrolstartframe = 76;
  // let scrollcontrolendframe = 137;
  if (animationisinviewport) {
    //     let boomrangstartframe = 61;
    // let boomrangendframe = 75;
    // let scrollcontrolstartframe = 76;
    // let scrollcontrolendframe = 137;
    // let loopstartframe = 138;
    // let loopendframe = 150;
    let isbooranging = false;
    if (frame >= boomrangstartframe && frame <= boomrangendframe) {
      isbooranging = true;
    }
    let islooping = false;
    if (frame >= loopstartframe && frame <= loopendframe) {
      islooping = true;
    }
    if (animationisinviewport && (isbooranging || islooping))
      if (isbooranging) {
        // if(animationisinviewport && (isbooranging || islooping) && scrollanimationdone == 0)
        setframe(boomrangendframe + 1);
      }
    if (islooping) {
      setframe(loopstartframe - 1);
    }
    playvideo = false;
    disableScroll();
    iswheelcontrol = true;
    // shouldbomrang = false;
    // shouldloop = false;
  } else {
    // console.log("animation is out of view port");
    playvideo = true;
    enableScroll();
    scrollanimationdone = 0;
    iswheelcontrol = false;
    shouldbomrang = true;
    shouldloop = true;
  }
  if (frame >= scrollcontrolstartframe && frame <= scrollcontrolendframe) {
    // check if animation is in view frame
    let ifanimationinviewframe = true;
    if (ifanimationinviewframe) {
      // stop scroll
      // stop video play
      //controll with wheel
    }
  }
}
// function to check if div is in viewport
// take element as input
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  // return (
  //     rect.top >= 0 &&
  //     rect.left >= 0 &&
  //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
  //     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  // );
  return rect.top >= -10 && rect.top <= 250;
}
// Loop video based on loopendframe and loopstartframe
// take current frame as argument
function loopvideo(frame) {
  if (shouldloop) {
    if (frame == loopendframe) {
      setframe(loopstartframe);
    }
  }
}
// Loop video based on boomrangstartframe
// boomrangframerate is the framerate
// call it when current frame == boomrangendframe
function boomrang(frame) {
  setframe(frame);
  playvideo = false;
  if (frame == boomrangstartframe) {
    playvideo = true;
    return true;
  } else {
    setTimeout(function () {
      frame = frame - 1;

      boomrang(frame);
    }, boomrangframerate);
  }
}
// function to count current frame count
function framecountis() {
  let count = 1;
  if (y > 1) {
    count = imagerows * (y - 1) + x;
  } else {
    count = x;
  }
  return count;
}
// set animation frame
// take frame as input
function setframe(frame) {
  if (frame > imagerows) {
    let mode = frame % imagerows;
    if (mode) {
      x = mode;

      y = (frame - mode) / imagerows + 1;
    } else {
      // getting stuck here
      //setframe(frame-1);
      x = imagerows;
      y = frame / imagerows;
      // console.log("Setting x,y as ", x,y)
    }
  } else {
    x = frame;
    y = 1;
  }
}
// create observer function

function createObserver() {
  ////////////////////////////////////////////////////////////
  ////////////// checking if video is in scroll //////////////
  document.addEventListener(
    "scroll",
    function () {
      const messageText = isInViewport(animation_container_parent)
        ? (animationisinviewport = true)
        : (animationisinviewport = false);

      // message.textContent = messageText;
    },
    {
      passive: true,
    }
  );
  // //////////// handle video with scroll/mouse wheel

  var videoReady = true; //set to true when video loads
  var continueUpdatingVideo = true;
  var increments = 1; //steps two seconds for each scroll event
  document.addEventListener("wheel", wheelfunction);
  window.addEventListener("touchstart", onTouchStart, {
    passive: false,
  });
  window.addEventListener("touchmove", onTouchMove, {
    passive: false,
  });

  let lastY;

  function onTouchStart(event) {
    lastY = event.touches[0].pageY;
  }

  function onTouchMove(event) {
    const currentY = event.touches[0].pageY;
    let deltaY = Math.round(currentY - lastY);
    // if(deltaY > 1){
    // 	deltaY = 1;
    // }
    // else{
    // 	deltaY = -1;
    // }
    lastY = currentY;
    if (videoReady && continueUpdatingVideo) {
      var delta = Math.max(-1, Math.min(1, deltaY)); //either +1 or -1
      if (iswheelcontrol && !playvideo) {
        updatevideowithwheel(delta * increments);
      }
    }
    // console.log(deltaY,lastY);
  }

  function wheelfunction(e) {
    if (videoReady && continueUpdatingVideo) {
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)); //either +1 or -1
      if (iswheelcontrol && !playvideo) {
        updatevideowithwheel(delta * increments);
      }
    }
    return false;
  }

  function updatevideowithwheel(delta) {
    delta = delta * -1;
    var videoLength = imagerows * imagecolumns;

    let setframevar = framecount + delta * scrollrate;
    // console.log(delta,setframevar,framecount,scrollrate)
    if (setframevar <= 0) {
      setframevar = 0;
    } else if (setframevar >= videoLength) {
      setframevar = videoLength;
    }

    // let scrollcontrolstartframe = 76;
    // let scrollcontrolendframe = 137;
    if (
      setframevar >= scrollcontrolendframe ||
      setframevar <= scrollcontrolstartframe - 2
    ) {
      playvideo = true;
      enableScroll();
      scrollanimationdone = 1;
      shouldloop = true;
      shouldbomrang = true;
    } else {
      setframe(setframevar);
      shouldloop = false;
    }
  }
}
// scroll enable and disable
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
// code for disable scroll and enable scroll
var keys = {
  37: 1,
  38: 1,
  39: 1,
  40: 1,
};

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
  window.addEventListener(
    "test",
    null,
    Object.defineProperty({}, "passive", {
      get: function () {
        supportsPassive = true;
      },
    })
  );
} catch (e) {}

var wheelOpt = supportsPassive
  ? {
      passive: false,
    }
  : false;
var wheelEvent =
  "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

// call this to Disable
function disableScroll() {
  window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
  window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
  window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
  window.addEventListener("keydown", preventDefaultForScrollKeys, false);
}

// call this to Enable
function enableScroll() {
  window.removeEventListener("DOMMouseScroll", preventDefault, false);
  window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
  window.removeEventListener("touchmove", preventDefault, wheelOpt);
  window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
}

// home page searchbox input
let rolesliContainer = document.querySelector(".home-searchbox .roles-list");
let locationliContainer = document.querySelector(
  ".home-searchbox .search-box-location-list ul"
);
let roleInputElem = document.querySelector(
  ".home-searchbox .search-box-roles-input"
);
let locationInputElem = document.querySelector(
  ".home-searchbox .search-box-location-input"
);
let searchInput = document.querySelector(".home-searchbox .searchbox-form");

let rolesSuggestions = [
  // "Registered Nurse – Wards",
  // "Registered Nurse – ITU",
  // "Registered Nurse",
  // "Registered Nurse– Outpatients (Bank)",
];

if (roleInputElem) {
  roleInputElem.addEventListener("focus", function () {
    let inputValue = roleInputElem.value;
    searchInput.classList.add("role-list-active");
    let filteredRoleWord = rolesSuggestions.filter(function (word) {
      return word.toLowerCase().includes(inputValue.toLowerCase());
      // return word.toLowerCase().startsWith(inputValue.toLowerCase())
    });
    suggestionRoleWordsGenerator(rolesSuggestions);

    // get jobs and update jobrolesSuggestions array;

    jQuery.ajax({
      type: "GET",
      url: jsonapiurl+"/wp-json/ps-india/v1/get_jobs_with_keyword",
      data: {
        action: "get_jobs_with_keyword",
        // add your parameters here

        keyword: inputValue,
        nonce: jsWpRestNonce
      },
      success: function (output) {
        rolesSuggestions = JSON.parse(output);
        //searchInput.classList.add("role-list-active");
        let filteredRoleWord = rolesSuggestions.filter(function (word) {
          return word.toLowerCase().includes(inputValue.toLowerCase());
        });
        suggestionRoleWordsGenerator(rolesSuggestions);
      },
    });

    
  });
  // Function to handle the input and make an AJAX call
function handlepscInput() {
  let inputValue = roleInputElem.value;
  if (inputValue) {
    searchInput.classList.add("role-list-active");
    // Filter rolesSuggestions based on the input value
    let filteredRoleWord = rolesSuggestions.filter(function (word) {
      return word.toLowerCase().includes(inputValue.toLowerCase());
    });
    suggestionRoleWordsGenerator(filteredRoleWord);

    // AJAX call to get jobs and update rolesSuggestions array
    jQuery.ajax({
      type: "GET",
      url: jsonapiurl+"/wp-json/ps-india/v1/get_jobs_with_keyword",
      data: {
        action: "get_jobs_with_keyword",
        keyword: inputValue,
        nonce: jsWpRestNonce
      },
      success: function (output) {
        rolesSuggestions = JSON.parse(output);
        let filteredRoleWord = rolesSuggestions.filter(function (word) {
          return word.toLowerCase().includes(inputValue.toLowerCase());
        });
        suggestionRoleWordsGenerator(filteredRoleWord);
      },
    });
  } else {
    searchInput.classList.remove("role-list-active");
  }
}

// Attach the debounced function to the keyup event
roleInputElem.addEventListener("keyup", debounce(handlepscInput, 900)); // 500ms delay
  // roleInputElem.addEventListener("keyup", function () {
  //   let inputValue = roleInputElem.value;
  //   if (inputValue) {
  //     searchInput.classList.add("role-list-active");
  //     let filteredRoleWord = rolesSuggestions.filter(function (word) {
  //       return word.toLowerCase().includes(inputValue.toLowerCase());
  //       // return word.toLowerCase().startsWith(inputValue.toLowerCase())
  //     });
  //     suggestionRoleWordsGenerator(rolesSuggestions);

  //     // get jobs and update jobrolesSuggestions array;

  //     jQuery.ajax({
  //       type: "POST",
  //       url: sitebaseurl + "/wp-admin/admin-ajax.php",
  //       data: {
  //         action: "get_jobs_with_keyword",
  //         // add your parameters here
  //         keyword: inputValue,
  //       },
  //       success: function (output) {
  //         rolesSuggestions = JSON.parse(output);
  //         //searchInput.classList.add("role-list-active");
  //         let filteredRoleWord = rolesSuggestions.filter(function (word) {
  //           return word.toLowerCase().includes(inputValue.toLowerCase());
  //         });
  //         suggestionRoleWordsGenerator(rolesSuggestions);
  //       },
  //     });
  //   }
  //   //   else {
  //   //   	 searchInput.classList.remove("role-list-active");
  //   //   }
  // });

  // showing list on focus
  roleInputElem.addEventListener("focus", function () {
    let inputValue = roleInputElem.value;
    searchInput.classList.add("role-list-active");
    searchInput.classList.remove("location-list-active");
    let filteredRoleWord = rolesSuggestions.filter(function (word) {
      return word.toLowerCase().includes(inputValue.toLowerCase());
      // return word.toLowerCase().startsWith(inputValue.toLowerCase())
    });
    suggestionRoleWordsGenerator(rolesSuggestions);
  });
}
function showallroleclicked(elem) {
  // skip it for now
}

let customRoleListItem;

function suggestionRoleWordsGenerator(wordArray) {
  let newwArray = [];

  if (wordArray.length > 1) {
    newwArray = ["Show All"].concat(wordArray);
  } else {
    newwArray = wordArray;
  }

  let suggestionWord = newwArray
    .map(function (word) {
      if (word == "Show All") {
        return "<li><a onclick='showallroleclicked(this)' href='#' class='show-all-roles-li'>Show All</a></li>";
      } else {
        return "<li><a href='#'>" + word + "</a></li>";
      }
    })
    .join("");

  if (suggestionWord) {
    rolesliContainer.innerHTML = suggestionWord;
    if (wordArray.length < 2) {
      rolesliContainer.innerHTML +=
        "<li aria-hidden='true'><a href='#' aria-hidden='true'></a></li>";
      rolesliContainer.innerHTML +=
        "<li aria-hidden='true'><a href='#' aria-hidden='true'></a></li>";
    }
  } else {
    rolesliContainer.innerHTML =
      "<li><a href='#'>" + roleInputElem.value + "</a></li>";
    rolesliContainer.innerHTML +=
      "<li aria-hidden='true'><a href='#' aria-hidden='true'></a></li>";
    rolesliContainer.innerHTML +=
      "<li aria-hidden='true'><a href='#' aria-hidden='true'></a></li>";
  }
  SelectRole();
}

function SelectRole() {
  let allListItems = rolesliContainer.querySelectorAll(".roles-list li");
  allListItems.forEach(function (wordItem) {
    if (wordItem) {
      wordItem.addEventListener("click", function (e) {
        if (e.target.textContent != "Show All") {
          roleInputElem.value = e.target.textContent;
        } else {
          if (!roleInputElem.value) {
            roleInputElem.value = e.target.textContent;
          }
        }

        searchInput.classList.remove("role-list-active");
        rolesliContainer.style.display = "none";
      });
    }
  });
}

// for location list
if (locationInputElem) {
  locationInputElem.addEventListener("focus", function () {
    let inputValue = roleInputElem.value;
    searchInput.classList.add("location-list-active");
    searchInput.classList.remove("role-list-active");
  });

  locationInputElem.addEventListener("keyup", function () {
    let inputValue = roleInputElem.value;
    if (inputValue) {
      searchInput.classList.add("location-list-active");
      searchInput.classList.remove("role-list-active");
    }
  });

  // showing list on focus
  locationInputElem.addEventListener("click", function () {
    let inputValue = roleInputElem.value;
    searchInput.classList.remove("role-list-active");
    searchInput.classList.add("location-list-active");
  });
}
let locationSuggestions = allhospitallocations;

let customLocationListItem;

function suggestionLocationWordsGenerator(wordArray) {
  let suggestionWord = wordArray
    .map(function (word) {
      return "<li><a href='#'>" + word + "</a></li>";
    })
    .join("");

  if (suggestionWord) {
    locationliContainer.innerHTML = suggestionWord;
  } else {
    locationliContainer.innerHTML =
      "<li><a href='#'>" + locationInputElem.value + "</a></li>";
  }
  Selectlocation();
}

function Selectlocation() {
  let allListItems = locationliContainer.querySelectorAll(
    ".search-box-location-list ul li"
  );
  allListItems.forEach(function (wordItem) {
    if (wordItem) {
      wordItem.addEventListener("click", function (e) {
        locationInputElem.value = e.target.textContent;
        searchInput.classList.remove("location-list-active");
        locationliContainer.style.display = "none";
      });
    }
  });
}

// heranimation play pause
let heroanimationplaypause = document.querySelector(
  ".heroanimation-play-pause-btn-div .heroanimation-play-pause-text"
);
if (heroanimationplaypause) {
  heroanimationplaypause.addEventListener("click", function (e) {
    e.preventDefault();
    heroanimationplaypause.classList.toggle("play");
    let heroanimation_playicon = document.querySelector(
      ".heroanimation-play-pause-btn-div .heroanimation-play-pause-text .heroanimation-play-icon"
    );
    let heroanimation_pauseicon = document.querySelector(
      ".heroanimation-play-pause-btn-div .heroanimation-play-pause-text .heroanimation-pause-icon"
    );

    if (heroanimationplaypause.classList.contains("play")) {
      heroanimation_pauseicon.style.display = "none";
      heroanimation_playicon.style.display = "inline-block";
    } else {
      heroanimation_pauseicon.style.display = "inline-block";
      heroanimation_playicon.style.display = "none";
    }
  });
}

// ******list closing on clicking on close icon ****//

let homewrapper = document.querySelector(".home-searchbox .searchbox-form");
let homesubmitbutton = document.querySelector(
  ".home-searchbox .searchbox-form .home-searchbox-btn"
);
let searchbox_roles_div = document.querySelector(
  ".home-searchbox .searchbox-form .search-box-roles"
);
let searchbox_roleslist = document.querySelector(
  ".home-searchbox .search-box-roles .roles-list"
);
// let searchbox_location_list = document.querySelector(".home-searchbox .search-box-locations .search-box-location-list ul");
if (homewrapper) {
  homewrapper.addEventListener("click", function (e) {
    // e.preventDefault();
    if (homewrapper.classList.contains("role-list-active")) {
      searchbox_roleslist.style.display = "block";
      let searchbox_role_close_icon = homewrapper.querySelector(
        ".searchbox-form .search-box-roles .roles-close-icon"
      );
      if (searchbox_role_close_icon) {
        searchbox_role_close_icon.addEventListener("click", function (e) {
          e.preventDefault();
          searchbox_roleslist.style.display = "none";
          homewrapper.classList.remove("role-list-active");
          roleInputElem.value = "";
        });
      }

      if (searchbox_role_close_icon) {
        searchbox_role_close_icon.addEventListener("keydown", function (e) {
          let isTabPressed = e.key === "Tab" || e.keyCode === 9;
          if (isTabPressed) {
            let searchbox_roles_input = document.querySelector(
              ".home-searchbox .searchbox-form .search-box-roles-input"
            );
            searchbox_roles_input.focus();
            e.preventDefault();
          }
        });
      }

      // if (searchbox_roleslist.matches(':focus-within')) {
      // 	let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      // 	let isEnterPressed = e.keyCode === 13;
      // 	if (isTabPressed) {
      // 		console.log('tab pressed');
      // 		roleInputElem.focus();
      // 	}
      // }
    }

    if (homewrapper.classList.contains("location-list-active")) {
      // searchbox_location_list.style.display = "block";
      searchbox_roleslist.style.display = "none";
      let searchbox_location_close_icon = homewrapper.querySelector(
        ".searchbox-form .search-box-locations .location-close-icon"
      );
      if (searchbox_location_close_icon) {
        searchbox_location_close_icon.addEventListener("click", function (e) {
          e.preventDefault();
          // searchbox_location_list.style.display = "none";
          homewrapper.classList.remove("location-list-active");
          locationInputElem.value = "";
        });
      }

      if (searchbox_location_close_icon) {
        searchbox_location_close_icon.addEventListener("keydown", function (e) {
          let isTabPressed = e.key === "Tab" || e.keyCode === 9;
          if (isTabPressed) {
            let searchbox_locations_input = document.querySelector(
              ".home-searchbox .searchbox-form .search-box-location-input"
            );
            searchbox_locations_input.focus();
            e.preventDefault();
          }
        });
      }
    }
  });
}

// ******* search job roles input form js start ******* //
let search_job_input_container = document.querySelector(
  ".search-jobs-input-container .search-jobs-contanier"
);
let search_jobs_roles_input = document.querySelector(
  ".search-job-roles-div .search-job-roles-input"
);
let search_job_roles_list = document.querySelector(
  ".search-job-roles-div .search-jobs-roles-list"
);
let search_job_roles_close_icon = document.querySelector(
  ".search-jobs-input-container .search-job-roles-div .search-roles-close-icon"
);
let jobrolesSuggestions = [];

if (search_jobs_roles_input) {
  search_jobs_roles_input.addEventListener("keyup", function () {
    let inputValue = search_jobs_roles_input.value;
    if (inputValue) {
      // get jobs and update jobrolesSuggestions array;

      jQuery.ajax({
        type: "GET",
        url: jsonapiurl+"/wp-json/ps-india/v1/get_jobs_with_keyword",
        data: {
          action: "get_jobs_with_keyword",
          // add your parameters here
          keyword: inputValue,
          nonce: jsWpRestNonce
        },
        success: function (output) {
          jobrolesSuggestions = JSON.parse(output);
          search_job_input_container.classList.add(
            "searchjob-role-list-active"
          );
          search_job_input_container.classList.remove(
            "searchjob-location-list-active"
          );
          search_job_input_container.classList.remove(
            "searchjob-salary-list-active"
          );
          let filteredJobRoleWord = jobrolesSuggestions.filter(function (word) {
            return word.toLowerCase().includes(inputValue.toLowerCase());
            // return word.toLowerCase().startsWith(inputValue.toLowerCase())
          });
          searchJobRolesGenerator(jobrolesSuggestions);
        },
      });
    }
    // else {
    // 	searchInput.classList.remove("role-list-active");
    // }
  });

  // showing list on focus
  search_jobs_roles_input.addEventListener("focus", function () {
    let inputValue = search_jobs_roles_input.value;
    search_job_input_container.classList.add("searchjob-role-list-active");
    search_job_input_container.classList.remove(
      "searchjob-location-list-active"
    );
    search_job_input_container.classList.remove("searchjob-salary-list-active");
    let filteredJobRoleWord = rolesSuggestions.filter(function (word) {
      return word.toLowerCase().includes(inputValue.toLowerCase());
      // return word.toLowerCase().startsWith(inputValue.toLowerCase())
    });
    searchJobRolesGenerator(rolesSuggestions);
  });
}

let customJobRoleListItem;

function searchJobRolesGenerator(wordArray) {
  let suggestionWord = wordArray
    .map(function (word) {
      return "<li><a href='#'>" + word + "</a></li>";
    })
    .join("");

  if (suggestionWord) {
    search_job_roles_list.innerHTML = suggestionWord;
  } else {
    search_job_roles_list.innerHTML =
      "<li><a href='#'>" + search_jobs_roles_input.value + "</a></li>";
  }
  selectJobRoles();
}

function selectJobRoles() {
  let allListItems = search_job_roles_list.querySelectorAll(
    ".search-jobs-roles-list li"
  );
  allListItems.forEach(function (wordItem) {
    if (wordItem) {
      wordItem.addEventListener("click", function (e) {
        search_jobs_roles_input.value = e.target.textContent;
        search_job_input_container.classList.remove(
          "searchjob-role-list-active"
        );
        // search_job_roles_list.style.display = "none";
      });
    }
  });
}

if (search_job_input_container) {
  search_job_input_container.addEventListener("click", function (e) {
    if (!e.target.classList.contains("search-job-location-input-google")) {
      e.preventDefault();
    }

    if (
      search_job_input_container.classList.contains(
        "searchjob-role-list-active"
      )
    ) {
      // search_job_roles_list.style.display = "block";
      if (search_job_roles_close_icon) {
        search_job_roles_close_icon.addEventListener("click", function (e) {
          e.preventDefault();
          // search_job_roles_list.style.display = "none";
          search_job_input_container.classList.remove(
            "searchjob-role-list-active"
          );
          search_jobs_roles_input.value = "";
        });
      }
    }
  });
}

// ******* search job roles input form js end ******* //
// ******* search job location input form js start ******* //
let search_jobs_locations_input = document.querySelector(
  ".search-jobs-input-container .search-jobs-locations-div .search-job-location-input"
);
let search_job_location_list = document.querySelector(
  ".search-jobs-input-container .search-jobs-locations-div .search-jobs-location-list"
);
let search_job_location_close_icon = document.querySelector(
  ".search-jobs-input-container .search-jobs-locations-div .searchjob-location-close-icon"
);
let searchjoblocationSuggestions = allhospitallocations;

if (search_jobs_locations_input) {
  search_jobs_locations_input.addEventListener("keyup", function () {
    let inputValue = search_jobs_locations_input.value;
    if (inputValue) {
      search_job_input_container.classList.add(
        "searchjob-location-list-active"
      );
      search_job_input_container.classList.remove("searchjob-role-list-active");
      search_job_input_container.classList.remove(
        "searchjob-salary-list-active"
      );
      if (searchjoblocationSuggestions) {
        let filteredJobLocationWord = searchjoblocationSuggestions.filter(
          function (word) {
            return word.toLowerCase().includes(inputValue.toLowerCase());
            // return word.toLowerCase().startsWith(inputValue.toLowerCase())
          }
        );
        searchJobLocationGenerator(filteredJobLocationWord);
      }
    }
  });

  // showing list on focus
  search_jobs_locations_input.addEventListener("focus", function () {
    let inputValue = search_jobs_locations_input.value;
    search_job_input_container.classList.add("searchjob-location-list-active");
    search_job_input_container.classList.remove("searchjob-role-list-active");
    search_job_input_container.classList.remove("searchjob-salary-list-active");
    if (searchjoblocationSuggestions) {
      let filteredJobLocationWord = searchjoblocationSuggestions.filter(
        function (word) {
          return word.toLowerCase().includes(inputValue.toLowerCase());
        }
      );
      searchJobLocationGenerator(filteredJobLocationWord);
    }
  });
}

let customJobLocationListItem;

function searchJobLocationGenerator(wordArray) {
  let suggestionWord = wordArray
    .map(function (word) {
      return "<li><a href='#'>" + word + "</a></li>";
    })
    .join("");

  if (suggestionWord) {
    search_job_location_list.innerHTML = suggestionWord;
  } else {
    search_job_location_list.innerHTML =
      "<li><a href='#'>" + search_jobs_locations_input.value + "</a></li>";
  }
  selectJobLocations();
}

function selectJobLocations() {
  let allListItems = search_job_location_list.querySelectorAll(
    ".search-jobs-location-list li"
  );
  allListItems.forEach(function (wordItem) {
    if (wordItem) {
      wordItem.addEventListener("click", function (e) {
        search_jobs_locations_input.value = e.target.textContent;
        search_job_input_container.classList.remove(
          "searchjob-location-list-active"
        );
        // search_job_location_list.style.display = "none";
      });
    }
  });
}

if (search_job_input_container) {
  search_job_input_container.addEventListener("click", function (e) {
    if (!e.target.classList.contains("search-job-location-input-google")) {
      e.preventDefault();
    }
    // e.preventDefault();
    if (
      search_job_input_container.classList.contains(
        "searchjob-location-list-active"
      )
    ) {
      // console.log("showing from here")
      // search_job_location_list.style.display = "block";
      if (search_job_location_close_icon) {
        search_job_location_close_icon.addEventListener("click", function (e) {
          e.preventDefault();
          // search_job_location_list.style.display = "none";
          search_job_input_container.classList.remove(
            "searchjob-location-list-active"
          );
          search_jobs_locations_input.value = "";
        });
      }
    }
  });
}

// salary input js

let search_jobs_salary_input = document.querySelector(
  ".search-jobs-input-container .search-job-salary-div .salary-range-input"
);
let search_job_salary_list = document.querySelector(
  ".search-jobs-input-container .search-job-salary-div .search-job-salary-list"
);
if (search_jobs_salary_input) {
  search_jobs_salary_input.addEventListener("keyup", function () {
    search_job_input_container.classList.add("searchjob-salary-list-active");
    search_job_input_container.classList.remove("searchjob-role-list-active");
    search_job_input_container.classList.remove(
      "searchjob-location-list-active"
    );
  });

  // showing list on focus
  search_jobs_salary_input.addEventListener("focus", function () {
    search_job_input_container.classList.add("searchjob-salary-list-active");
    search_job_input_container.classList.remove("searchjob-role-list-active");
    search_job_input_container.classList.remove(
      "searchjob-location-list-active"
    );
  });
}

// salary range input js
let salary_value_span = document.querySelector(
  ".search-jobs-input-container .search-job-salary-div .search-job-salary-list .salary-range-value"
);
let salary_input_minimum = document.querySelectorAll(
  ".search-jobs-input-container .search-job-salary-div .min-max-input-range .search-job-salary-minimum"
);
let salary_input_maximum = document.querySelectorAll(
  ".search-jobs-input-container .search-job-salary-div .min-max-input-range .search-job-salary-maximum"
);
let salary_done_btn = document.querySelector(
  ".search-jobs-input-container .search-job-salary-div .search-job-salary-list .salary-list-done"
);
if (salary_input_minimum) {
  for (let i = 0; i < salary_input_minimum.length; i++) {
    salary_input_minimum[i].addEventListener("input", function (e) {
      e.preventDefault();
      let result_value = e.target.value;
      e.target.parentNode.parentNode.querySelector(
        ".salary-min-value input"
      ).value = result_value;
    });
  }
}

if (salary_input_maximum) {
  for (let i = 0; i < salary_input_maximum.length; i++) {
    salary_input_maximum[i].addEventListener("input", function (e) {
      e.preventDefault();
      let result_value = e.target.value;
      e.target.parentNode.parentNode.querySelector(
        ".salary-max-value input"
      ).value = result_value;
    });
  }
}

// functionality on done btn
if (salary_done_btn) {
  salary_done_btn.addEventListener("click", function (e) {
    e.preventDefault();
    search_job_input_container.classList.remove("searchjob-salary-list-active");
    // search_jobs_salary_input.value = salary_value_span.innerHTML;
    let salary_min_val = e.target.parentNode.parentNode.querySelector(
      ".search-job-salary-minimum"
    ).value;
    let salary_max_val = e.target.parentNode.parentNode.querySelector(
      ".search-job-salary-maximum"
    ).value;
    e.target.parentNode.parentNode.querySelector(
      ".salary-min-value input"
    ).value = salary_min_val;
    e.target.parentNode.parentNode.querySelector(
      ".salary-max-value input"
    ).value = salary_max_val;
    // console.log(e.target.parentNode.parentNode.querySelector(".salary-range-input"));
    e.target.parentNode.parentNode.querySelector(".salary-range-input").value =
      "£" +
      numberWithCommas(salary_min_val) +
      " - " +
      "£" +
      numberWithCommas(salary_max_val);
  });
}

//on change events for salary inputs min max
let minsalarynum = document.querySelector(".salary-min-value input");
let maxsalarynum = document.querySelector(".salary-max-value input");

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

if (minsalarynum) {
  minsalarynum.addEventListener("change", function (e) {
    // let one = numberWithCommas(e.target.value);
    // console.log(one);
    // e.target.value= one;
    // minsalarynum.value="one";
    // minsalarynum.setAttribute('e.target.value','one');

    e.preventDefault();
    var inputLeft = document.querySelector(
      ".search-job-salary-div .search-job-salary-minimum"
    );
    var inputRight = document.querySelector(
      ".search-job-salary-div .search-job-salary-maximum"
    );
    var thumbLeft = document.querySelector(
      ".search-job-salary-div .slider > .thumb.left"
    );
    var range = document.querySelector(
      ".search-job-salary-div .slider > .range"
    );

    inputLeft.value = e.target.value;
    // e.target.value = one;
    var _this = inputLeft,
      min = parseInt(_this.min),
      max = parseInt(_this.max);

    _this.value = Math.min(
      parseInt(_this.value),
      parseInt(inputRight.value) - 1
    );

    var percent = ((_this.value - min) / (max - min)) * 100;
    percent = percent - percent / 10;
    thumbLeft.style.left = percent + "%";
    range.style.left = percent + "%";
  });
  minsalarynum.addEventListener("keypress", function (event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  });
}
if (maxsalarynum) {
  maxsalarynum.addEventListener("change", function (e) {
    numberWithCommas(maxsalarynum);
    e.preventDefault();
    var inputLeft = document.querySelector(
      ".search-job-salary-div .search-job-salary-minimum"
    );
    var inputRight = document.querySelector(
      ".search-job-salary-div .search-job-salary-maximum"
    );
    var thumbRight = document.querySelector(
      ".search-job-salary-div .slider > .thumb.right"
    );
    var range = document.querySelector(
      ".search-job-salary-div .slider > .range"
    );

    inputRight.value = e.target.value;
    var _this = inputRight,
      min = parseInt(_this.min),
      max = parseInt(_this.max);

    _this.value = Math.max(
      parseInt(_this.value),
      parseInt(inputLeft.value) + 1
    );

    var percent = ((_this.value - min) / (max - min)) * 100;
    let rpercent = 100 - percent;
    rpercent = rpercent - rpercent / 10;
    thumbRight.style.right = rpercent + "%";
    range.style.right = rpercent + "%";
  });
  maxsalarynum.addEventListener("keypress", function (event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  });
}
// resting value of close icon in salary  range
let search_job_salary_close_icon = document.querySelector(
  ".search-jobs-input-container .search-job-salary-div .salary-close-icon"
);
if (search_job_salary_close_icon) {
  search_job_salary_close_icon.addEventListener("click", function (e) {
    e.preventDefault();
    let minvalue = e.target.parentNode
      .querySelector(".search-job-salary-minimum")
      .getAttribute("min");
    let maxvalue = e.target.parentNode
      .querySelector(".search-job-salary-minimum")
      .getAttribute("max");
    e.target.previousSibling.previousSibling.querySelector(
      ".salary-min-value input"
    ).value = minvalue;
    e.target.previousSibling.previousSibling.querySelector(
      ".salary-max-value input"
    ).value = maxvalue;
    e.target.parentNode.querySelector(".search-job-salary-minimum").value =
      minvalue;
    e.target.parentNode.querySelector(".search-job-salary-maximum").value =
      maxvalue;
    e.target.parentNode.parentNode.querySelector(".salary-range-input").value =
      "";
    var thumbLeft = e.target.parentNode.querySelector(".slider > .thumb.left");
    thumbLeft.style.left = "0%";
    var thumbRight = e.target.parentNode.querySelector(
      ".slider > .thumb.right"
    );
    thumbRight.style.right = "0%";
    search_job_input_container.classList.remove("searchjob-salary-list-active");
  });
}

// Role input for job search page

// jQuery(document).ready(function() {
// 	jQuery(".mark-as-read").click(function () {
// 	 console.log('The function is hooked up');
// 	 jQuery.ajax({
// 		 type: "POST",
// 		 url: "/wp-admin/admin-ajax.php",
// 		 data: {
// 			 action: 'get_jobs_with_keyword',
// 			 // add your parameters here
// 			 keyword: $('.your-selector').val()
// 		 },
// 		 success: function (output) {
// 			console.log(output);
// 		 }
// 		 });
// 	 });
//  });

// $(window).scroll(function () {
// 	$(".landing-page-hero-parallax").css("opacity", 1 - $(window).scrollTop() / 650);
// });

// window.addEventListener('scroll', function(){
// 	let parallax_effect_div = document.querySelector(".parallax-effect");
// 	console.log(parallax_effect_div);
// 	let scroll_top_height = parallax_effect_div.scrollTop;
// 	console.log(scroll_top_height);
// 	// parallax_effect_div.style.opacity = "1";

// }

let clickonsecondli = document.querySelectorAll(
  ".leftandrightcontent .skiplink li a"
);
let allstickyscrollskiplinkli = document.querySelectorAll(
  ".leftandrightcontent .skiplink li"
);
let allstckyscrollrightli = document.querySelectorAll(
  ".leftandrightcontent .skiplink-content li"
);
if (allstckyscrollrightli) {
  if (allstckyscrollrightli[0]) {
    allstckyscrollrightli[0].classList.add("active");
  }
}
if (clickonsecondli) {
  for (let x = 0; x < clickonsecondli.length; x++) {
    clickonsecondli[x].addEventListener("click", function (e) {
      e.preventDefault();

      for (let y = 0; y < allstickyscrollskiplinkli.length; y++) {
        if (
          allstickyscrollskiplinkli[y].classList.contains("active_skiplink")
        ) {
          allstickyscrollskiplinkli[y].style.overflow = "hidden";
          allstickyscrollskiplinkli[y].style.transition = "all .4s ease";
          // allstickyscrollskiplinkli[y].querySelector("a").style.transition = "all .3s ease";
          allstickyscrollskiplinkli[y].querySelector(
            ".skiplinkcontent"
          ).style.transition = "all .4s ease";
          let heightc =
            allstickyscrollskiplinkli[y].querySelector(".skiplinkcontent")
              .offsetHeight + 20;

          //allstickyscrollskiplinkli[y].querySelector(".skiplinkcontent").style.marginTop = '-40%';
          allstickyscrollskiplinkli[y].querySelector(
            ".skiplinkcontent"
          ).style.marginTop = "-" + heightc + "px";

          //allstickyscrollskiplinkli[y].querySelector(".skiplinkcontent").style.transform = "translate(0px,-100%)";
          setTimeout(function () {
            allstickyscrollskiplinkli[y].classList.remove("active_skiplink");
            //allstickyscrollskiplinkli[y].querySelector(".skiplinkcontent").style.height = "auto";
            allstickyscrollskiplinkli[y].querySelector(
              ".skiplinkcontent"
            ).style.marginTop = "0px";
            //allstickyscrollskiplinkli[y].querySelector(".skiplinkcontent").style.transform = "translate(0px,0px)";
          }, 400);
        }
      }
      for (let z = 0; z < allstckyscrollrightli.length; z++) {
        allstckyscrollrightli[z].classList.remove("active");
        //  allstckyscrollrightli[z].style.display = "none";
        // 			allstckyscrollrightli[z].style.opacity = 0;
        // 			allstckyscrollrightli[z].style.transform = 'scale(0)';
        // window.setTimeout(function(){
        // 	allstckyscrollrightli[z].style.display = 'none';
        // },700); // timed to match animation-duration
      }

      let getlinkli = e.target.getAttribute("href");

      e.target.parentNode.classList.add("active_skiplink");
      let rightliselector = document.querySelector(getlinkli);
      if (rightliselector) {
        rightliselector.classList.add("active");
        // rightliselector.style.display = "block";
        // window.setTimeout(function(){
        // 	rightliselector.style.opacity = 1;
        // 	rightliselector.style.transform = 'scale(1)';
        //   },1000);
      }
    });
  }
}

// preferences facade
var preferences = {
  set: function (key, value) {
    if (!key || !value) {
      return;
    }

    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    //localStorage.setItem(key, value);
    setCookie(key, value, 365);
  },
  get: function (key) {
    //var value = localStorage.getItem(key);
    var value = getCookie(key);

    // if (!value) {
    // 	return;
    // }

    // // assume it is an object that has been stringified
    // if (value[0] === "{") {
    // 	value = JSON.parse(value);
    // }

    return value;
  },
  append: function () {
    // get all anchorfields
    //let allanchors = document.querySelectorAll('a,[href*="circlehealthgroup"], [href*="circlehealthgroup.dev"]');
    // let allanchors = document.querySelectorAll('a');
    // if (allanchors) {
    // 	for (let i = 0; i < allanchors.length; i++) {
    // 		if (allanchors[i].href) {
    // 			let url = new URL(allanchors[i].href);
    // 			let keyword = (preferences.get("keyword")) ? preferences.get("keyword") : "";
    // 			let location = (preferences.get("location")) ? preferences.get("location") : "";
    // 			let profession = (preferences.get("profession")) ? preferences.get("profession") : "";
    // 			if (keyword || location || profession) {
    // 				url.searchParams.set("preferences", keyword + "||" + location + "||" + profession);
    // 				allanchors[i].href = url;
    // 			}
    // 		}
    // 	}
    // }
  },
};

//// cookies specific function
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
// let locationpagesliders = document.querySelectorAll('.page-template-location-page-template-php .hospital-images-div');
// if(locationpagesliders){
// 	for(let i = 0; i < locationpagesliders.length; i++){
// 		locationpagesliders[i].addEventListener("click",function(e){
// 			//console.log(e.currentTarget.getAttribute("data-title"));
// 			preferences.set("location", e.currentTarget.getAttribute("data-title"));
// 		})
// 	}
// }
let jobsearchforms = document.querySelectorAll(".job-search-form");
if (jobsearchforms) {
  for (let i = 0; i < jobsearchforms.length; i++) {
    jobsearchforms[i].addEventListener("submit", function (e) {
      let keyword = e.target.querySelector(".search-box-roles-input");
      if (keyword) {
        if (keyword.value && allowPersonalisation) {
          preferences.set("keyword", keyword.value);
        }
      }
      let search_form_keyword = e.target.querySelector(
        ".search-job-roles-input"
      );
      if (search_form_keyword) {
        if (search_form_keyword.value && allowPersonalisation) {
          preferences.set("keyword", search_form_keyword.value);
        }
      }
      let location = e.target.querySelector(".search-box-location-input");
      // commenting for now because hospital location field dont have hospital names now
      // if (location) {
      // 	if (location.value) {
      // 		preferences.set("location", location.value);
      // 	}
      // }
      let search_form_location = e.target.querySelector(".Regions");
      if (search_form_location) {
        if (search_form_location.value && allowPersonalisation) {
          preferences.set("location", search_form_location.value);
        }
      }

      let profession = e.target.querySelector(".functional_area");
      if (profession) {
        if (profession.value && allowPersonalisation) {
          preferences.set("profession", profession.value);
        }
      }
    });
  }
}
window.addEventListener("load", (event) => {
  preferences.append();
});

let clickonfilterbutton = document.querySelector(
  ".search-job-filters .searchjob-filter-btn"
);
let addactiveclass = document.querySelector(".filter-btn-wrapeer");
if (clickonfilterbutton) {
  clickonfilterbutton.addEventListener("click", function (e) {
    e.preventDefault();
    addactiveclass.classList.add("active");
    //setTimeout(function(){
    let selectfirstinput = document.querySelector(
      ".role-type-div .select2-container"
    );
    if (selectfirstinput) {
      selectfirstinput.setAttribute("tabindex", "0");
      selectfirstinput.focus();
    }

    //},2000)

    clickonfilterbutton.style.display = "none";
  });
}

let clickoncrossicon = document.querySelector(".filter_cross_button");

if (clickoncrossicon) {
  clickoncrossicon.addEventListener("click", function (e) {
    e.preventDefault();
    // console.log(clickoncrossicon);

    addactiveclass.style.transform = "translate(0,-50%)";
    addactiveclass.style.opacity = "0";
    setTimeout(function () {
      addactiveclass.classList.remove("active");
      addactiveclass.style.transform = "translate(0,0)";
      addactiveclass.style.opacity = "1";
    }, 300);
    clickonfilterbutton.style.display = "inline-block";
    if (clickonfilterbutton) {
      clickonfilterbutton.focus();
    }
  });
}

// job search multiple location
let multiple_location_view_text = document.querySelectorAll(
  ".jobslisting ul.jobs_wrapper li.job .mutiple-location-wrapper .location-view-text"
);
let multi_location_list = document.querySelectorAll(
  ".jobslisting ul.jobs_wrapper li.job .mutiple-location-wrapper .multi-location-list-wrapper .multiple-location-list"
);
if (multiple_location_view_text) {
  for (let i = 0; i < multiple_location_view_text.length; i++) {
    let jobs_count = multiple_location_view_text[i].getAttribute("jobs_count");
    if (jobs_count < 2) {
      multiple_location_view_text[i].style.display = "none";
      multiple_location_view_text[i].parentNode.parentNode.querySelector(
        ".multiple-location-list"
      ).style.display = "block";
    }
    multiple_location_view_text[i].addEventListener("click", function (e) {
      e.preventDefault();

      multiple_location_view_text[i].classList.toggle("active-view");
      if (multiple_location_view_text[i].classList.contains("active-view")) {
        multiple_location_view_text[i].querySelector("span").innerHTML =
          "View less";
        multiple_location_view_text[i].parentNode.parentNode.querySelector(
          ".multiple-location-list"
        ).style.display = "block";
      } else {
        multiple_location_view_text[i].querySelector("span").innerHTML =
          "View all";
        multiple_location_view_text[i].parentNode.parentNode.querySelector(
          ".multiple-location-list"
        ).style.display = "none";
      }
    });
  }
}

let clickonsubmenuleveltwo = document.querySelectorAll(
  ".submenu-level-2 .sub-menu-item a"
);
if (clickonsubmenuleveltwo) {
  for (let i = 0; i < clickonsubmenuleveltwo.length; i++) {
    clickonsubmenuleveltwo[i].addEventListener("click", function (e) {
      location.href = e.target.href;
      let textclicked = e.target.text;
      if (textclicked && allowPersonalisation) {
        preferences.set("profession", textclicked);
      }
    });
  }
}
// let aboutusactiveclass= document.querySelectorAll(".aboutusanimation");
//  if(aboutusactiveclass){
// 	for(let x=0; x<aboutusactiveclass.length; x++){
// 		aboutusactiveclass[x].addEventListener("mouseover", function(e){
// 			aboutusactiveclass[x].classList.add("active");
// 		})

// 		aboutusactiveclass[x].addEventListener("mouseleave", function(e){

// 			aboutusactiveclass[x].classList.remove("active");
// 		})
// 	}

//  }

let sub_location_list = document.querySelectorAll(
  ".location-slider-wrapper .sub-location-list ul li a"
);
if (sub_location_list) {
  for (let a = 0; a < sub_location_list.length; a++) {
    sub_location_list[a].addEventListener("click", function (e) {
      // e.preventDefault();
      e.target.parentNode.classList.toggle("active");
      // console.log(sub_location_list[a].parentNode.toggle.classList("active"));
    });
  }
}

var modal = document.querySelector(".modal");
var modal_triggers = document.querySelectorAll(".location-slider");
var closeButton = document.querySelector(".close-button");

function toggleModal() {
  modal.classList.toggle("show-modal");
}

function windowOnClick(event) {
  if (event.target === modal) {
    toggleModal();
  }
}

if (document.querySelector(".modal") !== null) {
  closeButton.addEventListener("click", toggleModal);
}
window.addEventListener("click", windowOnClick);

if (modal_triggers) {
  for (let a = 0; a < modal_triggers.length; a++) {
    modal_triggers[a].addEventListener("click", function (e) {
      e.preventDefault();

      var getLocation = e.target.parentNode.getAttribute("data-city");
      var getTitle = e.target.parentNode.getAttribute("data-title");
      var getDescription = e.target.parentNode.getAttribute("data-description");
      var getAddress = e.target.parentNode.getAttribute("data-address");
      var getSlug = e.target.parentNode.getAttribute("data-slug");
      if (allowPersonalisation) {
        preferences.set("location", getTitle);
      }

      if (history.pushState) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?hospitalname=" +
          getSlug;
        window.history.pushState({ path: newurl }, "", newurl);
      }
      if (getLocation) {
        toggleModal();
      }
      document.getElementById("modal_location").textContent = getLocation;
      document.getElementById("modal_title").textContent = getTitle;
      document.getElementById("modal_description").textContent = getDescription;
      document.getElementById("modal_address").textContent = getAddress;
      document.getElementById("modal_map_direction").href =
        "https://www.google.com/maps/dir//" + getAddress;
    });
  }
}

// checking profession page video stop
// $video_id = document.getElementById("hero-animation-video");
// console.log($video_id);
// if($video_id){
// 	$video_id.addEventListener('ended', myHandler, false);
// 	function myHandler(e){
// 		e.preventDefault();
// 		console.log('ended');
// 	}
// }

// function isInViewport(video_id) {
// 	const rect = video_id.getBoundingClientRect();
// 	// return (
// 	//     rect.top >= 0 &&
// 	//     rect.left >= 0 &&
// 	//     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
// 	//     rect.right <= (window.innerWidth || document.documentElement.clientWidth)
// 	// );
// 	return (
// 		rect.top >= -10 &&
// 		rect.top <= 250

// 	);
// }

// window.onscroll = function(event) {
// 	$video_id = document.getElementById("hero-animation-video");
// 	if($video_id){
// 		isInViewport(document.getElementById("hero-animation-video"));
// 		// console.log('dadasd');
// 		// console.log($video_id.offsetLeft);
// 		$video_id.parentNode.parentNode.style.position = 'fixed';
// 	}
// };

// let menu_last_child = document.querySelectorAll(".main-navigation .three-level-menu-container ul.megamenu li");
// console.log($menu_last_child);
// if($menu_last_child){

// 	for (let a = 0; a<$menu_last_child.length; a++){
// 		// console.log($menu_last_child);
// 		$menu_last_child[a].lastChild.text;
// 	}
// }

// console.log(menulastelement);
// if (submenuleveltwolastelement) {
// 	for (let x = 0; x < submenuleveltwolastelement.length; x++) {
// 		submenuleveltwolastelement[x].addEventListener("keydown", function (e) {
// 			let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
// 			if (isTabPressed) {
// 				e.preventDefault();
// 				let focusonfirstsitem = e.target.parentNode.parentNode.parentNode.querySelector("a");
// 				// console.log(focusonfirstsitem);
// 				focusonfirstsitem.focus();
// 			}

// 		})
// 	}
// }

// let menu_last_element = document.querySelector(".megamenu>li:last-child ul>li:last-child");
// if(menu_last_element){
// 	menu_last_element.addEventListener('focusout', function(){
// 		let all_jobs_btn = document.querySelector(".desktop-header .searchjobctabutton a");
// 		all_jobs_btn.focus();

// 	})
// }

//const sliders = document.querySelectorAll(".job-scrolling-container");
/*
const sliders = document.querySelectorAll(".job-scrolling-container, .mainwrapperimages ");
      const preventClick = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      if(sliders){
        for(let i =0; i < sliders.length; i++){
            let slider = sliders[i];
            let isDown = false;
            let isDragged = false;
            let startX;
            let scrollLeft;

      slider.addEventListener("mousedown", e => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mouseup", (e) => {
        isDown = false;
        const elements = slider.querySelectorAll("a");
        if(isDragged){
            for(let i = 0; i<elements.length; i++){
                  elements[i].addEventListener("click", preventClick);
            }
        }
        else{
            for(let i = 0; i<elements.length; i++){
                  elements[i].removeEventListener("click", preventClick);
            }
        }
        slider.classList.remove("active");
        isDragged =  false;
      });
      slider.addEventListener("mousemove", e => {
        if (!isDown) return;
        isDragged =  true;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
        // console.log(walk);
      });
        }
      }
*/

// landing page hero animation parralex effect
// let landingpareheroanimation = document.querySelectorAll(".landing-page-hero-parallax");
// // animation effect for top section
// $(window).scroll(function () {

// 	if (landingpareheroanimation) {
// 		for (let i = 0; i < landingpareheroanimation.length; i++) {
// 			landingpareheroanimation[i].style.transform = "translate3d(0px, " + (200 * $(window).scrollTop() / 650) + "px, 0px)";
// 		}
// 	}

// });

// salary slider
window.addEventListener("DOMContentLoaded", (event) => {
  let salarysliderparent = document.querySelector(".search-job-salary-div");
  if (salarysliderparent) {
    activatingcustomsalaryslider();
  }
});

function activatingcustomsalaryslider() {
  var inputLeft = document.querySelector(
    ".search-job-salary-div .search-job-salary-minimum"
  );
  var inputRight = document.querySelector(
    ".search-job-salary-div .search-job-salary-maximum"
  );

  var thumbLeft = document.querySelector(
    ".search-job-salary-div .slider > .thumb.left"
  );
  var thumbRight = document.querySelector(
    ".search-job-salary-div .slider > .thumb.right"
  );
  var range = document.querySelector(".search-job-salary-div .slider > .range");

  function setLeftValue() {
    var _this = inputLeft,
      min = parseInt(_this.min),
      max = parseInt(_this.max);

    _this.value = Math.min(
      parseInt(_this.value),
      parseInt(inputRight.value) - 1
    );

    var percent = ((_this.value - min) / (max - min)) * 100;
    percent = percent - percent / 10;
    thumbLeft.style.left = percent + "%";
    range.style.left = percent + "%";
  }
  setLeftValue();

  function setRightValue() {
    var _this = inputRight,
      min = parseInt(_this.min),
      max = parseInt(_this.max);

    _this.value = Math.max(
      parseInt(_this.value),
      parseInt(inputLeft.value) + 1
    );

    var percent = ((_this.value - min) / (max - min)) * 100;
    //percent = percent - percent / 10;
    let rpercent = 100 - percent;
    rpercent = rpercent - rpercent / 10;

    thumbRight.style.right = rpercent + "%";
    range.style.right = rpercent + "%";
  }
  setRightValue();

  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);

  inputLeft.addEventListener("mouseover", function () {
    thumbLeft.classList.add("hover");
  });
  inputLeft.addEventListener("mouseout", function () {
    thumbLeft.classList.remove("hover");
  });
  inputLeft.addEventListener("mousedown", function () {
    thumbLeft.classList.add("active");
  });
  inputLeft.addEventListener("mouseup", function () {
    thumbLeft.classList.remove("active");
  });

  inputRight.addEventListener("mouseover", function () {
    thumbRight.classList.add("hover");
  });
  inputRight.addEventListener("mouseout", function () {
    thumbRight.classList.remove("hover");
  });
  inputRight.addEventListener("mousedown", function () {
    thumbRight.classList.add("active");
  });
  inputRight.addEventListener("mouseup", function () {
    thumbRight.classList.remove("active");
  });
}

function updateJobsWrapper() {
  // job listing
  let jobs_wrapper = document.querySelectorAll(".jobs_wrapper .job");

  if (jobs_wrapper) {
    for (let i = 0; i < jobs_wrapper.length; i++) {
      jobs_wrapper[i].style.cursor = "pointer";
      jobs_wrapper[i].setAttribute("role", "button");
      jobs_wrapper[i].setAttribute("aria-pressed", "false");
      jobs_wrapper[i].setAttribute("tabindex", "0");
      jobs_wrapper[i].addEventListener("keypress", function (e) {
        if (e.keyCode == 13) {
          if (!e.target.classList.contains("location-view-text")) {
            e.preventDefault();
            jobs_wrapper[i].setAttribute("aria-pressed", "true");
            let joburl = e.currentTarget.querySelector("a").href;

            location.href = joburl;
          }
        }
      });
      jobs_wrapper[i].addEventListener("click", function (e) {
        if (!e.target.classList.contains("location-view-text")) {
          e.preventDefault();
          jobs_wrapper[i].setAttribute("aria-pressed", "true");
          let joburl = e.currentTarget.querySelector("a").href;
          location.href = joburl;
        }
      });
    }
  }
}

updateJobsWrapper();

// making professions lsider clickable

let circleinnerslider = document.querySelectorAll(
  ".circle-inner-slider .glide__slide .slide"
);
let circleinnersliderli = document.querySelectorAll(
  ".circle-inner-slider .glide__slide"
);
if (circleinnersliderli) {
  if (window.matchMedia("(max-width: 960px)").matches) {
    for (let i = 0; i < circleinnersliderli.length; i++) {
      circleinnersliderli[i].addEventListener("mouseover", function (e) {
        e.preventDefault();
        // e.stopImmediatePropagation();

        e.currentTarget
          .querySelector(".slide")
          .setAttribute("aria-pressed", "true");
        let joburl = e.currentTarget.querySelector("a").href;
        location.href = joburl;
      });
    }
  }
}
if (circleinnerslider) {
  for (let i = 0; i < circleinnerslider.length; i++) {
    circleinnerslider[i].setAttribute("role", "button");
    circleinnerslider[i].setAttribute("aria-pressed", "false");
    circleinnerslider[i].setAttribute("tabindex", "-1");

    // add keypress event
    circleinnerslider[i].addEventListener("keypress", function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        e.currentTarget.setAttribute("aria-pressed", "true");
        let joburl = e.currentTarget.querySelector("a").href;
        location.href = joburl;
      }
    });
    circleinnerslider[i].addEventListener("click", function (e) {
      e.stopImmediatePropagation();

      e.currentTarget.setAttribute("aria-pressed", "true");
      let joburl = e.currentTarget.querySelector("a").href;
      location.href = joburl;
    });
  }
}

function scrollingIntoJobscountView() {
  // check if filter is applied in job search page
  let jobscountspan = document.querySelector("span.jobscount");

  if (jobscountspan) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    // Get the value of "keyword" in eg "https://example.com/?keyword=some_value"
    let keyword = params.keyword; // "some_value"
    let locations = params.locations; // "some_value"
    let salaryrange = params.salaryrange; // "some_value"
    let role_types = params.role_types; // "some_value"
    let hours = params.hours; // "some_value"
    let regions = params.regions; // "some_value"
    let sorting = params.sorting; // "some_value"
    if (
      keyword ||
      locations ||
      salaryrange ||
      sorting ||
      regions ||
      hours ||
      role_types
    ) {
      jobscountspan.scrollIntoView();
    }

    // check if any of the filter is selected
    // if yes add active class to
    if (regions || hours || role_types) {
      // trigger click on button
      let clickonfilterbutton = document.querySelector(
        ".search-job-filters .searchjob-filter-btn"
      );
      if (clickonfilterbutton) {
        clickonfilterbutton.click();
      }
    }
  }
}
window.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(function () {
    scrollingIntoJobscountView();
    // hide lft buttons for professions slider
    let allglideslickprev = document.querySelectorAll(".glide .slick-prev");
    for (let i = 0; i < allglideslickprev.length; i++) {
      allglideslickprev[i].classList.add("slick-disabled");
    }
  }, 300);
});

// binding, on load,  inut value change events to location input on mobile
window.addEventListener("DOMContentLoaded", (event) => {
  reSizeLocationInput();
  // horizontalScrolltotopbtn(); // scroll last to first
  add_top_to_bottom_btn(); //add top to bottom link
  deepLinkingHospitalsFromCTA(); // deeplinking locations code
  //checkhorizontalScroll();
  callingGoogleMapsandSortAutoComplete(); // Jobs sorting ang google auto complete function
  // scrollTopToBottomFunction(); // remove for now until confirmed
});

function reSizeLocationInput() {
  if (document.querySelector("body").offsetWidth < 960) {
    var input = document.querySelector(".search-box-location-input"); // get the input element
    if (input) {
      if (input.value) {
        setTimeout(function () {
          //var input = document.querySelector('.job-search-input-wrapper-google #address'); // get the input element

          input.style.width = input.value.length + "ch";
        }, 100);
      } else {
        let placeholder = "all locations";
        input.style.width = placeholder.length - 3 + "ch";
      }
    }
  }
}
var locationMobileInput = document.querySelector(".search-box-location-input"); // get the input element
if (locationMobileInput) {
  locationMobileInput.addEventListener("change", reSizeLocationInput); // bind the "resizeInput" callback on "input" event
}

// function horizontalScrolltotopbtn() {
// 	let button = document.querySelectorAll('.cir_horizontal_images_scroll_tp');
// 	if (!button) {
// 		return false;
// 	}
// 	for (let i = 0; i < button.length; i++) {
// 		button[i].addEventListener("click", function (e) {
// 			e.preventDefault();
// 			e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode.scrollIntoView();
// 		});
// 	}

// }

function checkhorizontalScroll() {
  let button = document.querySelectorAll(".circle_top_to_bottom");
  // console.log('start scroll');
  if (!button) {
    return false;
  }
  for (let i = 0; i < button.length; i++) {
    button[i].addEventListener("click", function (e) {
      setTimeout(function () {
        let videodiv = document.querySelectorAll(".ready-heading")[0];
        // console.log(videodiv.offsetTop - videodiv.offsetHeight);
        if (videodiv.offsetTop > 2000) {
          window.scrollTo(0, videodiv.offsetTop - videodiv.offsetHeight - 100);
        } else {
          window.scrollTo(0, videodiv.offsetTop);
        }
        // console.log(videodiv.scrollHeight);
        // //videodiv[i].scrollTop = videodiv[i].scrollHeight;
        //videodiv.scrollIntoView();
      }, 100);

      //e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode.scrollIntoView();
    });
  }
}

function add_top_to_bottom_btn() {
  let htmldc = document.querySelectorAll("body.home");
  var wrapper = document.createElement("span");
  var content = document.createElement("span");
  wrapper.className = "circle_top_to_bottom";
  wrapper.setAttribute("id", "top_to_bottom_arrow_btn");
  wrapper.setAttribute("tabindex", "-1");

  // make inline svg icon
  let template = document.createElement("template");
  template.innerHTML = `
	<svg xmlns="http://www.w3.org/2000/svg" width="16.88" height="26.182" viewBox="0 0 16.88 26.182">
	<g id="down_arrow" data-name="down arrow" transform="translate(16.325) rotate(90)">
	  <path id="Path_8" data-name="Path 8" d="M0,.519,11.126,0l-.464,11.18" transform="translate(17.255 0) rotate(45)" fill="none" stroke="#072169" stroke-linejoin="round" stroke-width="1.5"/>
	  <line id="Line_80" data-name="Line 80" x2="24.528" transform="translate(0 7.899)" fill="none" stroke="#072169" stroke-width="1.5"/>
	</g>
  </svg>
	`.trim();
  const svg = template.content.firstChild;

  var arrowspan = wrapper.appendChild(content);
  arrowspan.appendChild(svg);

  if (!htmldc) {
    return false;
  }
  for (let i = 0; i < htmldc.length; i++) {
    htmldc[i].appendChild(wrapper);
  }
}

// hospitals deep linking

function deepLinkingHospitalsFromCTA() {
  let hospitalsliders = document.querySelectorAll(
    ".page-template-location-page-template-php .location-slider-wrapper"
  );
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  let hospitalslug = params.hospitalname;
  if (!hospitalslug) {
    return false;
  }
  if (!hospitalsliders) {
    //die early
    return false;
  }

  for (let i = 0; i < hospitalsliders.length; i++) {
    let sliderlocationparent = "";
    let sliderfountcount = 0;
    let foundelement = "";
    let hospitalfound = hospitalsliders[i].querySelector(
      '[data-slug="' + hospitalslug + '"]'
    );
    if (hospitalfound) {
      sliderlocationparent = hospitalsliders[i];
      let allclides = hospitalsliders[i].querySelectorAll(".locations-slide");
      if (allclides) {
        for (let j = 0; j < allclides.length; j++) {
          //console.log("Location slide",allclides[j].getAttribute("data-slug"), j, sliderfountcount);

          if (allclides[j].getAttribute("data-slug") == hospitalslug) {
            foundelement = allclides[j];
            //console.log("breaking", foundelement);
            break;
          } else {
            sliderfountcount++;
          }
        }
      }

      // go to href
      if (sliderlocationparent) {
        location.hash = "#" + sliderlocationparent.id;
        let slicksl = sliderlocationparent.querySelector(".location-slider");
        //slicksl.slick('slickGoTo', sliderfountcount);
        if (sliderfountcount > 3) {
          sliderfountcount = Math.round(sliderfountcount - 1);
        }
        function clickslider(count, sliderlocationparent) {
          // if(count > 0){
          // 	setTimeout(function () {
          // 		sliderlocationparent.querySelector(".slick-next").click();
          // 		console.log("clicked",count);
          // 		clickslider(count-1,sliderlocationparent);
          // 	}, 500);
          // }
          // else{
          // setTimeout(function () {
          // 	foundelement.querySelector(".hospital-images-div").click();
          // }, sliderfountcount * 100)
          // }
          setTimeout(function () {
            foundelement.querySelector(".hospital-images-div").click();
          }, 100);
        }
        clickslider(sliderfountcount, sliderlocationparent);
        // for (let k = 0; k < sliderfountcount; k++) {
        // 	setTimeout(function () {
        // 		sliderlocationparent.querySelector(".slick-next").click();
        // 	}, 100);
        // }
        // setTimeout(function () {
        // 	foundelement.querySelector(".hospital-images-div").click();
        // }, sliderfountcount * 100)
      }
      // got to hospital
      // trigger click event
      break;
    }
  }
}

function callingGoogleMapsandSortAutoComplete() {
  if (document.querySelector("#sortingjob")) {
    $("#sortingjob").select2({
      placeholder: "Sort by",
      //  allowClear: true
      allowClear: true,
      //  tags: true,
      minimumResultsForSearch: -1,
      width: "210px",
    });
  }

  // google auto complete

  // Prepare location info object.
  // Attach listener to address input field.
  //googleAutocomplete.autocompleteField("address");
  const addressinput = document.querySelector(
    ".home-location-input .search-box-location-input"
  );
  if (addressinput) {
    const options = {
      componentRestrictions: {
        country: "uk",
      },
      fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: false,
      types: ["geocode"],
    };
    const autocomplete = new google.maps.places.Autocomplete(
      addressinput,
      options
    );
  }
}

function mapscallback() {
  // this is to be executed after maps api loaded
}

// function scrollTopToBottomFunction() {
// 	let button = document.querySelectorAll('.circle_top_to_bottom');
// 	let videodiv = document.querySelector('#video-scroller');
// 	if (!button) {
// 		return false;
// 	}
// 	if(!videodiv){
// 		return false;
// 	}
// 	for (let i = 0; i < button.length; i++) {

// 		window.onscroll = function() {
// 			//document.querySelector("#video-scroller").getBoundingClientRect().y

// 			if (document.documentElement.scrollTop > (videodiv.getBoundingClientRect().y + videodiv.clientHeight)) {
// 				button[i].classList.add("circle_top_to_bottom_fade_out_cls");
// 			  } else {
// 				button[i].classList.remove("circle_top_to_bottom_fade_out_cls");
// 			  }
// 		};
// 	}

// }

window.onload = function () {
  setTimeout(function () {
    let topbutton = document.getElementById("top_to_bottom_arrow_btn");
    if (topbutton) {
      document.getElementById("top_to_bottom_arrow_btn").className =
        "circle_top_to_bottom";
    }
  }, 1000);
};

//   document.addEventListener('keydown', e => {
// 	if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
// 	const focusElem = document.querySelector(':focus');
// 	const tabElements = [...document.querySelectorAll('.search-box-roles-input, .roles-list>li>a')];
// 	const tabElementsCount = tabElements.length - 1;
// 	if (!tabElements.includes(focusElem)) return;
// 	e.preventDefault();
// 	const focusIndex = tabElements.indexOf(focusElem);
// 	let elemToFocus;
// 	if (e.key === 'ArrowUp') elemToFocus = tabElements[focusIndex > 0 ? focusIndex - 1 : tabElementsCount];
// 	if (e.key === 'ArrowDown') elemToFocus = tabElements[focusIndex < tabElementsCount ? focusIndex + 1 : 0];
// 	elemToFocus.focus();
//   });

let Srch_box_roles = document.querySelectorAll(".search-box-roles");
// console.log('start scroll');
if (Srch_box_roles) {
  for (let i = 0; i < Srch_box_roles.length; i++) {
    Srch_box_roles[i].addEventListener("keydown", function (e) {
      if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
      const focusElem = Srch_box_roles[i].querySelector(":focus");
      const tabElements = [
        ...Srch_box_roles[i].querySelectorAll(
          ".search-box-roles-input, .roles-list>li>a"
        ),
      ];
      const tabElementsCount = tabElements.length - 1;
      if (!tabElements.includes(focusElem)) return;
      e.preventDefault();
      const focusIndex = tabElements.indexOf(focusElem);
      let elemToFocus;
      if (e.key === "ArrowUp")
        elemToFocus =
          tabElements[focusIndex > 0 ? focusIndex - 1 : tabElementsCount];
      if (e.key === "ArrowDown")
        elemToFocus =
          tabElements[focusIndex < tabElementsCount ? focusIndex + 1 : 0];
      elemToFocus.focus();
    });
  }
}
// if(lastFocusableElementsubmenu){
// 	lastFocusableElementsubmenu.addEventListener("keydown", function(e){
// 		let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
// 		let isShiftPressed = e.shiftKey;
// 		if(isTabPressed){
// 			let focusonbackmobilebutton= document.querySelector(".nav__link.sub__close");
// 			focusonbackmobilebutton.focus();
// 		}
// 	})
// }

// open cookie console
let otsdkbtn = document.querySelector("#ot-sdk-btn");
if (otsdkbtn) {
  otsdkbtn.addEventListener("click", function (e) {
    CookieControl.open();
  });
}

(function () {
  let jobbackbtnall = document.querySelectorAll(".job-back-btn");
  if (!jobbackbtnall) {
    return false;
  }
  for (let i = 0; i < jobbackbtnall.length; i++) {
    jobbackbtnall[i].addEventListener("click", function (e) {
      e.preventDefault();
      window.history.back();
    });
  }
})();


// only for search fetaure on search page
jQuery(document).ready(function ($) {

  // checking if we are on job search page
  let areweonjobssearchpage = document.querySelector(".page-template-jobs-search-page-template");
  if(!areweonjobssearchpage){
    return;
  }
  

  let page = "1";

  let loading = false;
  let noMoreJobs = false;
  let throttleTimeout = null;

  // Create and append the loader element
  $("#infinite-scroll-loader").hide();
  $(".jobs-pagination .page-numbers").hide();
  function load_jobs_scroll(keyword = "", locations = "", sorting = "", sortingstatus = "") {
    if(page == 1){
      page++;
    }
    if (loading || noMoreJobs) return;
    loading = true;

   // $("#infinite-scroll-loader").show();
    $("#infinite-scroll-loader-after").show();

    $.ajax({
      url: jsonapiurl+"/wp-json/ps-india/v1/search_ps_jobs",
      type: "GET",
      data: {
        action: "search_ps_jobs",
        page: page,
        keyword: keyword,
        locations: locations,
        sorting: sorting,
        nonce: jsWpRestNonce
      },
      success: function (response) {
        try {
          
          response = JSON.parse(response);
          console.log(response)
          $(".job-count-container").html(response.jobscount_data);
          if (sortingstatus == 1) {
            $("#job-results").html('Loading...');
            $("#job-results").html(response.content);
          } else if(page == 1) {
            $("#job-results").html('Loading...');
            $("#job-results").html(response.content);
          } else {
            $("#job-results").append(response.content);
          }
          updateJobsWrapper();
          if (!response.more_posts || response.jobscount_data <= 10) {
            noMoreJobs = true;
          }
          else{
            page++;
          }

          // Update the URL
          // Extract the current URL and find the index of /job-search
          let currentUrl = new URL(window.location.href);
          let pathSegments = currentUrl.pathname.split("/");
          let jobSearchIndex = pathSegments.indexOf("job-search");
          let baseUrl =
            currentUrl.origin +
            pathSegments.slice(0, jobSearchIndex + 1).join("/");

          // Construct the new URL with page number
          let newUrl = new URL(`${baseUrl}/`);

          // Set query parameters
          if (keyword) {
            newUrl.searchParams.set("keyword", keyword);
          } else {
            newUrl.searchParams.delete("keyword");
          }
          if (locations) {
            newUrl.searchParams.set("locations", locations);
          } else {
            newUrl.searchParams.delete("locations");
          }
          if (sorting) {
            newUrl.searchParams.set("sorting", sorting);
          } else {
            newUrl.searchParams.delete("sorting");
          }

          window.history.pushState(null, "", newUrl.toString());
         // $("#infinite-scroll-loader").hide();
          $("#infinite-scroll-loader-after").hide();
          loading = false;
        } catch (e) {
          console.log("7000 Error: ", e);
        //  $("#infinite-scroll-loader").hide();
          $("#infinite-scroll-loader-after").hide();
          loading = false;
        }
      },
      error: function (xhr, status, error) {
       // console.log("7000 Error: " + error);
       // $("#infinite-scroll-loader").hide();
        $("#infinite-scroll-loader-after").hide();
        loading = false;
      },
    });
  }
  function load_jobs(page, keyword = "", locations = "", sorting = "", sortingstatus = "") {
    if (loading || noMoreJobs) return;
    loading = true;

   // $("#infinite-scroll-loader").show();
    $("#infinite-scroll-loader-after").show();

    $.ajax({
      url: jsonapiurl+"/wp-json/ps-india/v1/search_ps_jobs",
      type: "GET",
      data: {
        action: "search_ps_jobs",
        page: page,
        keyword: keyword,
        locations: locations,
        sorting: sorting,
        nonce: jsWpRestNonce
      },
      success: function (response) {
        try {
          
          response = JSON.parse(response);
          $(".job-count-container").html(response.jobscount_data);
          if (sortingstatus == 1) {
            $("#job-results").html('Loading...');
            $("#job-results").html(response.content);
          } else if(page == 1) {
            $("#job-results").html('Loading...');
            $("#job-results").html(response.content);
          } else {
            $("#job-results").append(response.content);
          }
          updateJobsWrapper();
          if (!response.more_posts || response.jobscount_data <= 10) {
            noMoreJobs = true;
          }

          // Update the URL
          // Extract the current URL and find the index of /job-search
          let currentUrl = new URL(window.location.href);
          let pathSegments = currentUrl.pathname.split("/");
          let jobSearchIndex = pathSegments.indexOf("job-search");
          let baseUrl =
            currentUrl.origin +
            pathSegments.slice(0, jobSearchIndex + 1).join("/");

          // Construct the new URL with page number
          let newUrl = new URL(`${baseUrl}/`);

          // Set query parameters
          if (keyword) {
            newUrl.searchParams.set("keyword", keyword);
          } else {
            newUrl.searchParams.delete("keyword");
          }
          if (locations) {
            newUrl.searchParams.set("locations", locations);
          } else {
            newUrl.searchParams.delete("locations");
          }
          if (sorting) {
            newUrl.searchParams.set("sorting", sorting);
          } else {
            newUrl.searchParams.delete("sorting");
          }

          window.history.pushState(null, "", newUrl.toString());
           $("#infinite-scroll-loader").hide();
          $("#infinite-scroll-loader-after").hide();
          loading = false;
        } catch (e) {
          console.log("70001 Error: ", e);
        //  $("#infinite-scroll-loader").hide();
          $("#infinite-scroll-loader-after").hide();
          loading = false;
        }
      },
      error: function (xhr, status, error) {
       // console.log("7000 Error: " + error);
       // $("#infinite-scroll-loader").hide();
        $("#infinite-scroll-loader-after").hide();
        loading = false;
      },
    });
  }

  

  var ps_updateInterval = null;
  var ps_previousCount = null;
  //var ps_checkForActiveJobsAndUpdateCount_js = null;

  function ps_checkForActiveJobsAndUpdateCount() {
    $.ajax({
      url: jsonapiurl+"/wp-json/ps-india/v1/ps_check_active_jobs",
      type: "GET",
      timeout: 10000,
      data: {
        action: "ps_check_active_jobs",
        nonce: jsWpRestNonce 
      },
      success: function (response) {
        if (response.success && response.data.has_active_jobs) {
          // ps_updateJobCount();
          // //clearInterval(ps_checkForActiveJobsAndUpdateCount_js);
          // ps_updateInterval = setInterval(function () {
          //   ps_updateJobCount();
          // }, 15000); // Update every 5 seconds
          $(".job-count-container > .jobscount").append(
            '<div class="job_count_loading_warapper"><div class="job_count_loading job_count_loading-0"></div><div class="job_count_loading job_count_loading-1"></div><div class="job_count_loading job_count_loading-2"></div></div>'
          );
        } else {
          var jobsCountContainer = $('.job-count-container > .jobscount');

          if (jobsCountContainer.length > 0) {
              // Check if it contains .job_count_loading_warapper
              var loadingWrapper = jobsCountContainer.find('.job_count_loading_warapper');
      
              if (loadingWrapper.length > 0) {
                  // Remove the .job_count_loading_warapper element
                  loadingWrapper.remove();
              }
          }
        }
      },
      error: function (xhr, status, error) {
        //console.log("7002 error: " + error);
      },
    });
  }


  function ps_updateJobCount() {
    let keyword = $('input[name="keyword"]').val();
    let locations = $('input[name="locations"]').val();
    let sorting = $('select[name="sorting"]').val();
    if (keyword) {
      var keyword_data = " " + keyword + " jobs found";
    } else {
      var keyword_data = " jobs found";
    }
    $.ajax({
      url: jsonapiurl+"/wp-json/ps-india/v1/ps_get_job_count",
      type: "GET",
      data: {
        action: "ps_get_job_count",
        keyword: keyword,
        locations: locations,
        sorting: sorting,
        nonce: jsWpRestNonce
      },
      success: function (response) {
        var ps_currentCount = response.data.count;
        if (response.success) {
          if (
            ps_previousCount !== null &&
            ps_previousCount === ps_currentCount
          ) {
            $(".job-count-container > .jobscount").html(
              response.data.count + keyword_data
            );
            //clearInterval(ps_updateInterval);
            // ps_checkForActiveJobsAndUpdateCount_js = setInterval(function () {
            //   ps_checkForActiveJobsAndUpdateCount();
            // }, 15000);
          } else {
            $(".job-count-container > .jobscount").html(
              response.data.count + keyword_data
            );
            $(".job-count-container > .jobscount").append(
              '<div class="job_count_loading_warapper"><div class="job_count_loading job_count_loading-0"></div><div class="job_count_loading job_count_loading-1"></div><div class="job_count_loading job_count_loading-2"></div></div>'
            );
          }

          ps_previousCount = ps_currentCount;
        } else {
          console.log("7003 error: " + response.data.message);
        }
      },
      error: function (xhr, status, error) {
        console.log("7004 error: " + error);
      },
    });
  }

  // Check for active jobs and start updating job count if active jobs are present
 // ps_checkForActiveJobsAndUpdateCount();
  // ps_checkForActiveJobsAndUpdateCount_js = setInterval(function () {
  //   ps_checkForActiveJobsAndUpdateCount();
  // }, 15000); // Update every 5 seconds

   
  

    // creating debounce object for checking jobs count every 30 sec
    let ps_checkForActiveJobsAndUpdateCountDebounce = debounce(ps_checkForActiveJobsAndUpdateCount, 30000);
      // running on load
    ps_checkForActiveJobsAndUpdateCountDebounce();
  
  

  $("#job-search-form").submit(function (e) {
    // Debugging line to check if the event listener is triggered
    //console.log('Form submission prevented');

    // Prevent the form from submitting
    e.preventDefault();
   
    ps_checkForActiveJobsAndUpdateCountDebounce();
    page = 1;
    noMoreJobs = false; // Reset noMoreJobs when a new search is initiated
    let keyword = $('input[name="keyword"]').val();
    let locations = $('input[name="locations"]').val();
    let sorting = $('select[name="sorting"]').val();
    $("#infinite-scroll-loader").show();
    load_jobs(page, keyword, locations, sorting);
	// setTimeout(() => {
	// 	$("#infinite-scroll-loader").hide();
	// }, 500);
	
  });

  $("#sortingjob").change(function (e) {
    e.preventDefault();
   // ps_checkForActiveJobsAndUpdateCountDebounce();
    //ps_checkForActiveJobsAndUpdateCount();
    page = 1;
    noMoreJobs = false; // Reset noMoreJobs when a new search is initiated
    let keyword = $('input[name="keyword"]').val();
    let locations = $('input[name="locations"]').val();
    let sorting = $('select[name="sorting"]').val();
    let sortingstatus = 1;
  
    load_jobs(page, keyword, locations, sorting, sortingstatus);
  });
  

  $(window).scroll(function () {
    if (loading || noMoreJobs) return; // Ignore if already loading or no more jobs
    let windowHeight = $(window).height();
    let footerTop = $(".site-footer").offset().top;
    let scrollTop = $(window).scrollTop();
    let scrollTrigger = 350; // Set the scroll trigger threshold
	  var countFoundPosts = document.getElementById('count_found_posts');
	if (countFoundPosts) {
		var countText = countFoundPosts.textContent;
		var countNumber = parseInt(countText, 10);

		if (countNumber < 10) {
			return false;
		} 
	}
    if (footerTop - windowHeight - scrollTop < scrollTrigger) {
      //console.log("loading new jobs");
      if (throttleTimeout) return; // Prevent consecutive requests
      throttleTimeout = setTimeout(function () {
       // page++;
        let keyword = $('input[name="keyword"]').val();
        let locations = $('input[name="locations"]').val();
        let sorting = $('select[name="sorting"]').val();
        load_jobs_scroll(keyword, locations, sorting);
        throttleTimeout = null;
      }, 200); // Throttle time of 1 second
    }
  });
});

// job count on job import
jQuery(document).ready(function ($) {
  
});

$(document).ready(function () {
  $(window).scroll(function () {
    if (window.scrollY > 500) {
      // Check scroll position using vanilla JavaScript
      $("#ps_bottom_to_top").fadeIn();
    } else {
      $("#ps_bottom_to_top").fadeOut();
    }
  });

  $("#ps_bottom_to_top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
});

// Function to hide .roles-list
function hideRolesList() {
  var rolesList = document.querySelector(".roles-list");
  if (rolesList) {
    // Check if the element exists
    searchbox_roleslist.style.display = "none";
    homewrapper.classList.remove("role-list-active");
  }
}

// Handle button click
var searchButton = document.querySelector(".home-searchbox-btn");
if (searchButton) {
  searchButton.addEventListener("click", function () {
    hideRolesList();
  });

  // Handle Enter key press
  searchButton.addEventListener("keypress", function (event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      hideRolesList();
    }
  });
}
